// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/header.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/BANER_login.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/BANER_register.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3E%3Cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/supply_baner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../images/BANER_Dashboard.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/header-payment.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    color: #383749;
    font-size: 15px;
    line-height: 1.8;
    font-family: 'Roboto', sans-serif;
}

/* img {
    vertical-align: baseline;
} */

/*--------------------------------------------------------------
# Links
--------------------------------------------------------------*/
a {
    color: #383749;
}

a:visited {
    color: #757686;
}

a:hover,
a:focus,
a:active {
    color: #383749;
    text-decoration: none;
}

a:focus {
    outline: thin dotted;
}

a:hover,
a:active {
    outline: 0;
    list-style: none;
}

/*--------------------------------------------------------------
# Helper Utilities
--------------------------------------------------------------*/
.flex {
    display: flex !important;
}

/*--------------------------------------------------------------
# Site Header
--------------------------------------------------------------*/
.site-header {
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
}

.top-header-bar {
    background: #fff;
}

/*
# Header Bar Text
--------------------------------*/
.header-bar-text,
.header-bar-email {
    padding: 11px 26px;
}

.header-bar-text .fa,
.header-bar-email .fa {
    margin-right: 12px;
    font-size: 20px;
    color: #19c880;
}

.header-bar-text p {
    margin: 0;
}

/*
# Header Bar Email
--------------------------------*/
.header-bar-email {
    padding-left: 16px;
    border-right: 1px solid #ebebeb;
}

.header-bar-email a {
    color: #383749;
    text-decoration: none;
}

/*
# Header Bar search
--------------------------------*/
.header-bar-search input[type="search"] {
    width: 280px;
    padding: 12px 26px;
    border: 0;
    line-height: 1;
    background: #f3f3f3;
    color: #383749;
}

.header-bar-search input[type="search"]::placeholder {
    color: #757686;
}

.header-bar-search input[type="search"]:focus {
    outline: none;
}

.header-bar-search button[type="submit"] {
    width: 50px;
    height: 50px;
    border: 0;
    color: #fff;
    background: #19c880;
    cursor: pointer;
    outline: none;
}

@media screen and (max-width: 1200px) and (min-width: 992px) {
    .header-bar-search input[type="search"] {
        width: 240px;
    }
}

@media screen and (max-width: 576px) {

    .header-bar-search,
    .header-bar-menu {
        width: 100%;
    }

    .header-bar-search input[type="search"] {
        width: calc(100% - 50px);
    }
}

/*
# Header Bar Menu
--------------------------------*/
.header-bar-menu ul {
    padding: 0 16px 0 32px;
    margin: 0;
    list-style: none;
}

.header-bar-menu li a {
    position: relative;
    display: block;
    padding: 0 6px;
    color: #383749;
}

.header-bar-menu li a::after {
    content: '/';
    position: absolute;
    top: 50%;
    right: -3px;
    width: 6px;
    margin-top: -12px;
}

.header-bar-menu li:nth-last-of-type(1) a::after {
    display: none;
}

/*
# Nav Bar
--------------------------------*/
.nav-bar {
    padding: 14px 0;
    background: rgba(255, 255, 255, .1);
}

/*
# Site Branding
--------------------------------*/
.site-title {
    padding: 10px 0;
    margin: 0;
    font-size: 36px;
    font-weight: 500;
    line-height: 1;
    text-align: left !important;
}

.site-title a {
    color: #fff;
    text-decoration: none;
}

.site-title a span {
    color: #19c880;
}

@media screen and (min-width: 576px) {
    /*.site-title {*/
    /*font-size: 112px;*/
    /*}*/
}

/*
  Hamburger Menu
----------------------------------------*/
.hamburger-menu {
    position: relative;
    width: 24px;
    height: 22px;
    margin: 0 auto;
    transition: .5s ease-in-out;
    cursor: pointer;
}

.hamburger-menu span {
    display: block;
    position: absolute;
    height: 2px;
    width: 100%;
    background: #fff;
    border-radius: 10px;
    opacity: 1;
    left: 0;
    transition: .25s ease-in-out;
}

.hamburger-menu span:nth-child(1) {
    top: 2px;
}

.hamburger-menu span:nth-child(2),
.hamburger-menu span:nth-child(3) {
    top: 10px;
}

.hamburger-menu span:nth-child(4) {
    top: 18px;
}

.hamburger-menu.open span:nth-child(1) {
    top: 18px;
    width: 0;
    left: 50%;
}

.hamburger-menu.open span:nth-child(2) {
    transform: rotate(45deg);
}

.hamburger-menu.open span:nth-child(3) {
    transform: rotate(-45deg);
}

.hamburger-menu.open span:nth-child(4) {
    top: 18px;
    width: 0;
    left: 50%;
}

/*
# Main Menu
--------------------------------*/
.site-navigation ul {
    margin: 0;
    list-style: none;
    position: fixed;
    top: 0;
    left: -320px;
    z-index: 9999;
    width: 320px;
    max-width: calc(100% - 120px);
    height: 100%;
    overflow-x: scroll;
    padding: 30px 15px;
    background: rgba(0, 0, 0, .9);
    transition: all 0.35s;
}

.site-navigation.show ul {
    left: 0;
}

.site-navigation ul li a {
    display: block;
    padding: 12px 26px;
    color: #fff;
    text-decoration: none;
    text-transform: uppercase;
}

@media screen and (min-width: 992px) {
    .site-navigation ul {
        position: relative;
        top: auto;
        left: auto;
        width: 100%;
        height: auto;
        padding: 0;
        overflow: auto;
        background: transparent;
    }
}

.site-navigation ul li a:hover,
.site-navigation ul li.current-menu-item a {
    color: #19c880;
}

/*
# Menu SHopping Cart
--------------------------------*/
.header-bar-cart {
    margin-left: 40px;
}

.header-bar-cart a {
    width: 48px;
    height: 100%;
}

.header-bar-cart a {
    color: #fff;
    text-decoration: none;
}

/*--------------------------------------------------------------
# Hero Section
--------------------------------------------------------------*/
.hero-content {
    /* background: url("images/hero-bg.jpg") no-repeat center; */
    background-size: cover;
    height: 130px;
}

.hero-content-overlay {
    background: rgba(21, 20, 33, .5);
}

.hero-content-wrap {
    height: 820px;
    padding-top: 130px;
}

.hero-content-wrap h4 {
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
    color: #19c880;
    letter-spacing: 0.1em;
}

.hero-content-wrap h1 {
    margin-top: 12px;
    font-size: 60px;
    font-weight: 500;
    text-transform: uppercase;
    color: #fff;
}

@media screen and (max-width: 576px) {
    .hero-content-wrap h1 {
        font-size: 32px;
    }
}

.hero-content-wrap p {
    margin-top: 8px;
    color: #fff;
}

.hero-content-wrap .read-more {
    margin-top: 40px;
}

.hero-content-wrap .read-more a {
    display: block;
    padding: 12px 40px;
    border: 2px solid #19c880;
    font-size: 13px;
    font-weight: bold;
    color: #fff;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    text-decoration: none;
}

.hero-content-wrap .read-more a:hover {
    background: #19c880;
}

/*--------------------------------------------------------------
# Homepage
--------------------------------------------------------------*/
/*
# Icon Box
--------------------------------*/
.services-section {
    border-bottom: 1px solid #ebebeb;
}

.icon-box {
    width: 25%;
    padding: 50px 60px 50px;
    border-right: 1px solid #ebebeb;
}

@media screen and (max-width: 1440px) {
    .icon-box {
        padding: 40px;
    }
}

@media screen and (max-width: 992px) {
    .icon-box {
        width: 50%;
    }

    .icon-box:nth-of-type(2) {
        border-right: 0;
    }

    .icon-box:nth-of-type(1),
    .icon-box:nth-of-type(2) {
        border-bottom: 1px solid #ebebeb;
    }
}

@media screen and (max-width: 576px) {
    .icon-box {
        width: 100%;
        border-right: 0;
        border-bottom: 1px solid #ebebeb;
    }
}

.icon-box:nth-last-of-type(1) {
    border-right: 0;
}

.icon-box .icon {
    font-size: 42px;
    color: #19c880;
}

.icon-box .entry-title {
    margin-top: 12px;
    font-size: 22px;
}

.icon-box .entry-content p {
    margin: 12px 0;
    color: #757686;
    line-height: 1.6;
}

.icon-box .read-more a {
    position: relative;
    padding-right: 10px;
    font-size: 13px;
    font-weight: 700;
    color: #19c880;
    text-decoration: none;
    text-transform: uppercase;
    letter-spacing: 0.1em;
}

.icon-box .read-more a .fa {
    position: absolute;
    top: 2px;
    left: 0;
    width: 100%;
    height: 100%;
    background: #fff;
    transition: all .35s;
}

.icon-box:hover .read-more a .fa {
    left: 100%;
}

/*
# Courses
--------------------------------*/
.courses-wrap .heading .entry-title {
    margin: 0;
    font-size: 42px;
    font-weight: 400;
}

.courses-wrap .heading .courses-menu ul {
    padding: 0;
    margin: 0;
    list-style: none;
}

.courses-wrap .heading .courses-menu li {
    padding-left: 40px;
}

.courses-wrap .heading .courses-menu li:nth-of-type(1) {
    padding-left: 0;
}

.courses-wrap .heading .courses-menu li a {
    border-bottom: 1px solid transparent;
    font-size: 18px;
    line-height: 1;
    color: #383749;
    text-decoration: none;
}

.courses-wrap .heading .courses-menu li a:hover,
.courses-wrap .heading .courses-menu li.active a {
    color: #19c880;
    border-color: #19c880;
}

.mx-m-25 {
    margin-right: -25px !important;
    margin-left: -25px !important;
}

.px-25 {
    padding-right: 25px !important;
    padding-left: 25px !important;
}

.course-content {
    margin-top: 50px;
    transition: all .35s
}

.course-content:hover {
    box-shadow: 0 24px 38px rgba(81, 107, 117, .21);
}

.course-thumbnail {
    width: 100%;
    margin: 0;
    object-fit: cover;
}

.course-thumbnail img {
    display: block;
    width: 100%;
    object-fit: cover;
}

.course-content-wrap {
    padding: 26px 30px 20px;
    border: 1px solid #ebebeb;
    border-top: 0;
    background: #fff;
}

.course-content .entry-title {
    margin: 0;
    font-size: 20px;
    line-height: 1.3;
    font-weight: 400;
}

.course-content .entry-title a {
    color: #383749;
}

.course-content .entry-meta {
    margin-top: 12px;
}

.course-author {
    font-style: italic;
}

.course-author a {
    color: #19c880;
    text-decoration: none;
}

.course-date {
    position: relative;
    padding-left: 10px;
    margin-left: 5px;
    color: #757686;
}

.course-date::before {
    content: '/';
    position: absolute;
    top: 0;
    left: 0;
    width: 10px;
    text-align: center;
}

.course-content .entry-footer {
    margin-top: 14px;
}

.course-cost {
    font-size: 24px;
    font-weight: 700;
    color: #19c880;
}

.course-cost .price-drop {
    margin-left: 10px;
    font-size: 20px;
    font-weight: 400;
    font-style: italic;
    color: #c0c1cd;
    text-decoration: line-through
}

.course-cost .free-cost {
    font-size: 24px;
    font-weight: 700;
    color: #f3a90b;
}

.course-ratings {
    font-size: 13px;
    color: #c0c1cd;
}

.course-ratings span {
    margin-left: 1px;
}

.course-ratings .checked {
    color: #f3a90b;
}

.course-ratings .course-ratings-count {
    margin-left: 5px;
}

a.btn {
    padding: 16px 48px;
    border: 2px solid #34d986;
    border-radius: 0;
    font-size: 13px;
    font-weight: bold;
    line-height: 1;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: #383749;
    text-decoration: none;
    cursor: pointer;
}

a.btn:hover {
    color: #fff;
    background: #34d986;
}

.btn {
    cursor: pointer;
}

/*
# Featured Courses: Horizontal Column
--------------------------------*/
.featured-courses.horizontal-column,
.featured-courses.vertical-column {
    padding: 100px 0;
    background: #fff;
}

.featured-courses.horizontal-column .course-thumbnail {
    width: calc(50% - 30px);
    background: #fff;
}

.featured-courses.horizontal-column .course-thumbnail img {
    height: 100%;
}

.featured-courses.horizontal-column .course-content-wrap {
    width: calc(50% + 30px);
    padding-left: 30px;
    border: 1px solid #ebebeb;
    border-left: 0;
}

.featured-courses.horizontal-column .course-ratings {
    margin-bottom: 8px;
}



@media screen and (max-width: 576px) {
    .featured-courses.horizontal-column .course-thumbnail {
        width: 100%;
    }

    .featured-courses.horizontal-column .course-content-wrap {
        width: 100%;
        padding: 30px;
        border: 1px solid #ebebeb;
        border-top: 0;
    }
}

/*
# Featured Courses: Vertical Column
--------------------------------*/
.featured-courses.vertical-column {
    background: #f7f7f7;
}

.featured-courses.vertical-column a.btn {
    margin-top: 60px;
}

/*
# About Section
--------------------------------*/
.about-section {
    padding: 100px 0;
    background: #f7f7f7;
}

.about-section .heading {
    padding-right: 80px;
}

.about-section .heading .entry-title {
    margin: 0;
    font-size: 42px;
    font-weight: 400;
}

.about-section .heading p {
    margin-top: 15px;
    font-size: 16px;
    line-height: 1.8;
    color: #757686;
}

.ezuca-stats {
    padding-right: 80px;
}

.ezuca-stats .stats-count {
    width: 50%;
    margin-top: 16px;
    font-size: 60px;
    line-height: 1.2;
    color: #19c880;
}

@media screen and (max-width: 576px) {
    .ezuca-stats .stats-count {
        width: 100%;
    }
}

.ezuca-stats .stats-count span {
    font-size: 36px;
}

.ezuca-stats .stats-count p {
    font-size: 16px;
    color: #757686;
    text-transform: uppercase;
}

/*
# About Section: Video
--------------------------------*/
.ezuca-video {
    width: 100%;
}

.ezuca-video .video-play-btn {
    top: 50%;
    left: -40px;
    z-index: 99;
    width: 80px;
    height: 80px;
    margin-top: -40px;
    cursor: pointer;
}

.ezuca-video img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

@media screen and (max-width: 992px) {
    .about-section .heading {
        padding-right: 0;
    }

    .ezuca-stats {
        padding-right: 0;
    }

    .ezuca-video .video-play-btn {
        left: 50%;
        margin-left: -40px;
    }
}

/*
# About Section: Testimonial
--------------------------------*/
.testimonial-section {
    padding: 100px 0;
}

.testimonial-slider .swiper-slide .user-avatar {
    opacity: .3;
    margin-bottom: 0;
}

.testimonial-slider .swiper-slide.swiper-slide-active .user-avatar {
    opacity: 1;
}

.testimonial-slider .swiper-slide:nth-of-type(2) .user-avatar,
.testimonial-slider .swiper-slide:nth-of-type(5) .user-avatar {
    margin-left: calc(50% - 150px);
}

.testimonial-slider .swiper-slide:nth-of-type(3) .user-avatar {
    margin-left: calc(50% - 40px);
}

.testimonial-slider .swiper-slide:nth-of-type(1) .user-avatar,
.testimonial-slider .swiper-slide:nth-of-type(4) .user-avatar {
    margin-left: calc(50% + 70px);
}


.testimonial-slider .swiper-slide-next {
    opacity: 1 !important;
}

.testimonial-slider .user-avatar {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    overflow: hidden;
}

.testimonial-slider .user-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.testimonial-slider .content-wrap {
    background: #fff;
}

.testimonial-slider .entry-content p {
    font-size: 26px;
    color: #383749;
}

.testimonial-slider .testimonial-user {
    display: inline-block;
    position: relative;
    font-size: 16px;
    font-weight: 300;
    text-transform: uppercase;
    color: #19c880;
}

.testimonial-slider .testimonial-user::after {
    content: '';
    position: absolute;
    top: -12px;
    right: -100px;
    width: 38px;
    height: 32px;
    /* background: url("images/quote-icon.png") no-repeat center; */
}

.testimonial-slider .testimonial-user span {
    font-size: 14px;
    color: #c0c1cd;
    text-transform: initial;
}

.testimonial-slider .swiper-pagination-bullet {
    width: 12px;
    height: 12px;
    margin: 0 6px;
    border: 2px solid #c6adb8;
    background: transparent;
    opacity: 1;
}

.testimonial-slider .swiper-pagination-bullet.swiper-pagination-bullet-active {
    background: #19c880;
    border: transparent;
}

/*
# Latest News & Events
--------------------------------*/
.latest-news-events {
    padding: 100px 0;
}

.latest-news-events .heading .entry-title {
    margin: 0 0 50px;
    font-size: 42px;
    font-weight: 400;
}

.latest-news-events .featured-event-content .event-thumbnail img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.latest-news-events .featured-event-content .posted-date {
    bottom: 0;
    left: 0;
    padding: 10px 16px;
    background: #f3a90b;
    color: #fff;
    line-height: 1;
    text-align: center;
}

.latest-news-events .featured-event-content .posted-date .day {
    font-size: 48px;
    font-weight: bold;
}

.latest-news-events .featured-event-content .posted-date .month {
    margin-top: 4px;
    font-size: 18px;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.1em;
}

.latest-news-events .featured-event-content {
    padding-right: 20px;
}

.latest-news-events .featured-event-content .entry-title {
    width: 100%;
    margin-top: 32px;
    font-size: 30px;
    font-weight: 400;
    color: #383749;
}

.latest-news-events .featured-event-content .event-location .fa,
.latest-news-events .featured-event-content .event-duration .fa {
    margin-right: 6px;
    color: #34d986;
}

.latest-news-events .featured-event-content .event-location,
.latest-news-events .featured-event-content .event-duration {
    margin-top: 8px;
    font-size: 14px;
    text-transform: uppercase;
    color: #c0c1cd;
}

.latest-news-events .featured-event-content .event-location {
    margin-right: 24px;
}

.event-content {
    margin-bottom: 30px;
}

.event-content .event-thumbnail {
    width: 200px;
    height: 200px;
    margin: 0;
}

.event-content .event-thumbnail a {
    display: block;
}

.event-content .event-content-wrap {
    width: calc(100% - 230px);
}

.event-content .posted-date .fa {
    margin-right: 6px;
    color: #34d986;
}

.event-content .posted-date {
    font-size: 14px;
    text-transform: uppercase;
    color: #c0c1cd;
}

.event-content .entry-title {
    margin: 8px 0 0;
    font-size: 20px;
    line-height: 1.3;
    font-weight: 400;
}

.event-content .entry-title a {
    color: #383749;
}

.event-content .post-author {
    margin-top: 14px;
}

.event-content .post-author a {
    font-style: italic;
    color: #19c880;
    text-decoration: none;
}

.event-content .post-comments {
    position: relative;
    padding-left: 12px;
    margin-top: 14px;
    margin-left: 5px;
    color: #757686;
}

.event-content .post-comments a {
    text-decoration: none;
    color: #757686;
}

.event-content .post-comments::before {
    content: '/';
    position: absolute;
    top: 0;
    left: 0;
    width: 10px;
    text-align: center;
}

.event-content .entry-content {
    margin-top: 14px;
    margin-bottom: 0;
    font-size: 16px;
    color: #757686;
}

.event-content .entry-content p {
    margin: 0;
}

@media screen and (max-width: 576px) {
    .event-content .event-thumbnail {
        width: 100%;
        margin-bottom: 24px;
    }

    .event-content .event-content-wrap {
        width: 100%;
    }

}

/*
# Gallery
--------------------------------*/
.home-gallery {
    overflow: hidden;
}

.gallery-wrap {
    margin-right: -5px;
    margin-left: -5px;
}

.gallery-grid {
    margin: 5px;
    overflow: hidden;
}

.gallery-grid img {
    display: block;
    max-width: 100%
}

.gallery-grid1x1 {
    width: calc(100% / 8 - 10px);
}

.gallery-grid2x1,
.gallery-grid2x2 {
    width: calc(100% / 4 - 10px);
    margin-bottom: 6px;
}

.gallery-grid2x2 {
    width: calc(100% / 4 - 10px);
    margin-bottom: 7px;
}

@media screen and (max-width: 1200px) {
    .gallery-grid1x1 {
        width: calc(100% / 4 - 10px);
    }

    .gallery-grid2x1,
    .gallery-grid2x2 {
        width: calc(100% / 2 - 10px);
    }

    .gallery-grid2x2 {
        width: calc(100% / 2 - 10px);
    }
}

@media screen and (max-width: 576px) {
    .gallery-grid1x1 {
        width: calc(100% / 2 - 10px);
    }

    .gallery-grid2x1,
    .gallery-grid2x2 {
        width: calc(100% / 1- 10px);
        margin-bottom: 6px;
    }

    .gallery-grid2x2 {
        width: calc(100% / 1 - 10px);
        margin-bottom: 7px;
    }
}

/*
# Clients Logos
--------------------------------*/
.clients-logo {
    margin-top: 100px;
    padding: 16px 0;
    background: #f7f7f7;
}

.logo-wrap {
    margin: 16px;
}

/*--------------------------------------------------------------
# Courses Page
--------------------------------------------------------------*/
.page-header {
    background-size: cover !important;
}

.courses-page .page-header {
    /* background: url("images/courses-header.jpg") no-repeat center; */
}

.page-header-overlay {
    background: rgba(21, 20, 33, .5);
    height: 390px;
    padding-top: 236px;
}

.page-header h1 {
    font-size: 48px;
    font-weight: 500;
    color: #fff;
    text-align: center;
    padding-top: 100px;
    text-transform: capitalize;
}

/*--------------------------------------------------------------
# Breadcrumb
--------------------------------------------------------------*/
.breadcrumbs {
    margin: 30px 0;
}

.breadcrumbs ul {
    list-style: none;
}

.breadcrumbs li {
    position: relative;
    padding-right: 16px;
    margin-right: 10px;
    color: #c0c1cd;
}

.breadcrumbs li::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 6px;
    height: 100%;
    font-family: 'FontAwesome';
}

.breadcrumbs li:nth-last-of-type(1)::after {
    display: none;
}

.breadcrumbs li a {
    color: #383749;
    text-decoration: none;
}

/*--------------------------------------------------------------
# Pagination
--------------------------------------------------------------*/
.pagination {
    margin-top: 50px;
}

.pagination ul {
    list-style: none;
}

.pagination ul li {
    margin-right: 10px;
}

.pagination ul li a {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 38px;
    border: 1px solid #ebebeb;
    color: #757686;
    text-decoration: none;
}

.pagination ul li a .fa {
    color: #383749;
}

.pagination ul li:hover a,
.pagination ul li.active a {
    border-color: transparent;
    background: #19c880;
}

.pagination ul li:hover a,
.pagination ul li.active a,
.pagination ul li:hover a .fa {
    color: #fff;
}

.pagination-results {
    color: #383749;
}

.pagination-results select {
    padding: 6px 10px;
    margin-left: 32px;
    border: 1px solid #ebebeb;
}

/*--------------------------------------------------------------
# Sidebar
--------------------------------------------------------------*/
.sidebar {
    padding: 25px;
    margin-top: 50px;
    margin-left: 25px;
    border: 1px solid #ebebeb;
}

@media screen and (max-width: 992px) {
    .sidebar {
        margin-left: 0;
    }
}

/*
# Search
--------------------------------*/
.search-widget input[type="search"] {
    width: calc(100% - 48px);
    height: 48px;
    padding: 10px 20px;
    border: 1px solid #ebebeb;
    font-size: 14px;
    background: #f7f7f7;
    color: #383749;
    outline: none;
}

.search-widget input[type="search"]::placeholder {
    color: #c0c1cd;
}

.search-widget button[type="submit"] {
    width: 48px;
    height: 48px;
    border: 0;
    background: #19c880;
    color: #fff;
    cursor: pointer;
    outline: none;
}

/*
# Categories
--------------------------------*/
.cat-links {
    margin-top: 50px;
}

.cat-links h2 {
    margin-bottom: 16px;
    font-size: 24px;
    font-weight: 400;
}

.cat-links ul {
    list-style: none;
}

.cat-links ul li {
    position: relative;
    padding: 8px 0 8px 24px;
}

.cat-links ul li::before {
    content: '';
    position: absolute;
    top: 8px;
    left: 0;
    width: 8px;
    height: 100%;
    font-size: 14px;
    font-family: 'FontAwesome';
    color: #c0c1cd;
    ;
}

.cat-links ul li:hover::before {
    color: #19c880;
}

.cat-links ul li a {
    text-decoration: none;
}

/*
# Latest Courses
--------------------------------*/
.latest-courses {
    margin-top: 50px;
}

.latest-courses h2 {
    margin-bottom: 16px;
    font-size: 24px;
    font-weight: 400;
}

.latest-courses li {
    display: block;
    margin-bottom: 20px;
}

.latest-courses li img {
    width: 84px;
}

.latest-courses .content-wrap {
    width: calc(100% - 108px);
}

.latest-courses .content-wrap h3 {
    font-size: 16px;
    font-weight: 500;
    line-height: 1.6;
}

.latest-courses .content-wrap h3 a {
    color: #383749;
    text-decoration: none;
}

.latest-courses .content-wrap .course-cost {
    margin-top: 10px;
    font-size: 18px;
    font-weight: 500;
}

.latest-courses .content-wrap .course-cost.free-cost {
    color: #f3a90b;
}

/*
# Ads
--------------------------------*/
.ads {
    margin-top: 50px;
}

.ads img {
    max-width: 100%;
}

/*
# Latest Courses
--------------------------------*/
.popular-tags {
    margin-top: 50px;
}

.popular-tags h2 {
    margin-bottom: 16px;
    font-size: 24px;
    font-weight: 400;
}

.popular-tags ul {
    list-style: none;
}

.popular-tags li a {
    display: block;
    padding: 8px 14px;
    margin-right: 8px;
    margin-bottom: 8px;
    border: 1px solid #ebebeb;
    font-size: 12px;
    line-height: 1;
    text-transform: uppercase;
    color: #595959;
    text-decoration: none;
}

.popular-tags li a:hover {
    color: #383749;
}

/*--------------------------------------------------------------
# Single Courses Page
--------------------------------------------------------------*/
.single-courses-page .page-header {
    /* background: url("images/single-courses-bg.jpg") no-repeat center; */
}

.single-courses-page .page-header-overlay {
    height: 530px;
}

.single-courses-page .page-header-overlay h1 {
    text-transform: uppercase;
}

.single-courses-page .featured-image {
    position: relative;
    margin-top: -80px;
    box-shadow: 0 24px 38px rgba(81, 107, 117, .21);
}

.single-courses-page .featured-image img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.single-courses-page .featured-image .course-cost {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 120px;
    padding: 10px;
    font-size: 22px;
    font-weight: bold;
    color: #f3a90b;
    background: #fff;
    text-align: center;
}

@media screen and (max-width: 992px) {
    .single-courses-page .featured-image {
        margin-top: 80px;
    }
}

/*
# Course Info
--------------------------------*/
.course-info {
    margin-top: 40px;
}

.course-info label {
    color: #c0c1cd;
}

.course-info .course-author,
.course-info .course-cats,
.course-info .course-students {
    padding-right: 20px;
    margin-right: 20px;
    border-right: 1px solid #ebebeb;
}

.course-author img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin-right: 20px;
}

.course-author a {
    color: #19c880;
}

.course-students {
    border: 0;
}

.single-course-cont-section {
    margin-top: 24px;
    color: #757686;
}

.single-course-cont-section h2 {
    margin-top: 24px;
    margin-bottom: 16px;
    font-size: 24px;
    font-weight: 400;
    color: #383749;
}

ul.green-ticked {
    list-style: none;
}

ul.green-ticked li {
    position: relative;
    padding-left: 24px;
    margin-top: 8px;
}

ul.green-ticked li::before {
    content: '';
    position: absolute;
    top: 2px;
    left: 0;
    width: 20px;
    height: 100%;
    font-size: 14px;
    font-family: 'FontAwesome';
    color: #19c880;
}

ul.black-doted {
    list-style: none;
}

.single-course-cont-section ul.black-doted li {
    position: relative;
    padding-left: 24px;
    margin-top: 8px;
}

.single-course-cont-section ul.black-doted li::before {
    content: '';
    position: absolute;
    top: 3px;
    left: 0;
    width: 16px;
    height: 100%;
    font-size: 9px;
    font-family: 'FontAwesome';
}

.single-course-accordion-cont h2 {
    width: calc(100% - 280px);
    /*min-width: 320px;*/
    margin-top: 24px;
    margin-bottom: 16px;
    font-size: 24px;
    font-weight: 400;
    color: #383749;
}

.single-course-accordion-cont .number-of-lectures,
.single-course-accordion-cont .lectures-preview,
.single-course-accordion-cont .total-lectures-time {
    font-size: 18px;
    color: #19c880;
}

.single-course-accordion-cont .number-of-lectures,
.single-course-accordion-cont .lectures-preview {
    width: 140px;
}

.single-course-accordion-cont .total-lectures-time,
.single-course-accordion-cont .lectures-time {
    width: 120px;
    text-align: right;
}

.single-course-accordion-cont .accordion-wrap .entry-title {
    padding: 10px 16px 9px;
    margin: 10px 0 0;
    border: 1px solid #ebebeb;
}

.single-course-accordion-cont .accordion-wrap .entry-content {
    padding: 10px 16px;
    border: 1px solid #ebebeb;
    border-top: 0;
}

.single-course-accordion-cont .arrow-d,
.single-course-accordion-cont .arrow-r {
    position: relative;
    padding-right: 10px;
    color: #19c880;
}

.single-course-accordion-cont .entry-title.active .fa-plus {
    display: none;
}

.single-course-accordion-cont .entry-title .fa-minus {
    display: none;
}

.single-course-accordion-cont .entry-title.active .fa-minus {
    display: block;
}

.single-course-accordion-cont h3 {
    font-size: 16px;
    font-weight: 400;
    color: #757686;
}

.single-course-accordion-cont .lecture-group-title {
    width: calc(100% - 300px);
}

.single-course-accordion-cont ul {
    list-style: none;
    color: #757686;
}

.single-course-accordion-cont ul li {
    margin-top: 8px;
}

.single-course-accordion-cont .lecture-title {
    width: calc(100% - 280px);
    color: #757686;
}

.single-course-accordion-cont .lectures-preview,
.single-course-accordion-cont .lectures-time {
    color: #757686;
}

.instructors-info {
    margin-top: 50px;
}

.instructors-info .entry-heading h2 {
    padding-bottom: 16px;
    margin-bottom: 50px;
    border-bottom: 1px solid #ebebeb;
    font-size: 24px;
    font-weight: 400;
    color: #383749;
}

.instructors-stats {
    width: 200px;
    margin-right: 30px;
}

.instructors-stats img {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    border: 1px solid #ebebeb;
}

.instructors-stats ul {
    list-style: none;
}

.instructors-stats li {
    margin-top: 10px;
}

.instructors-stats .fa {
    margin-right: 2px;
    font-size: 14px;
    font-family: 'FontAwesome';
    color: #19c880;
}

.instructors-details {
    width: calc(100% - 230px);
}

.instructors-details .ratings {
    color: #c0c1cd;
}

.instructors-details .ratings .fa-star-o {
    color: #c0c1cd;
}

.instructors-details .ratings span {
    margin-left: 4px;
}

.instructors-details h2 {
    font-size: 30px;
    font-weight: 400;
    color: #383749;
}

.instructors-details .course-teacher {
    color: #c0c1cd;
}

.instructors-details .course-teacher a {
    color: #19c880;
    font-weight: 600;
    text-transform: uppercase;
    -webkit-text-decoration: navajowhite;
            text-decoration: navajowhite;
}

.instructors-details .entry-content {
    color: #757686;
    line-height: 1.8;
}

.related-courses {
    margin-top: 50px;
}

.related-courses .entry-heading {
    padding-bottom: 16px;
    border-bottom: 1px solid #ebebeb;
}

.related-courses .entry-heading h2 {
    font-size: 24px;
    font-weight: 400;
    color: #383749;
}

.related-courses .entry-heading a {
    color: #19c880;
    text-decoration: underline;
}

@media screen and (max-width: 992px) {
    .single-course-accordion-cont .lecture-group-title {
        width: calc(100% - 24px);
        margin-bottom: 12px;
    }

    .single-course-accordion-cont h2,
    .single-course-accordion-cont .lecture-title {
        width: 100%;
    }

    .single-course-accordion-cont ul li {
        margin-top: 24px;
    }

    .single-course-accordion-cont .total-lectures-time,
    .single-course-accordion-cont .lectures-time,
    .single-course-accordion-cont .number-of-lectures,
    .single-course-accordion-cont .lectures-preview {
        width: auto;
        text-align: left;
    }

    .instructors-details {
        margin-top: 50px;
        width: 100%;
    }
}

/*--------------------------------------------------------------
# Ratings
--------------------------------------------------------------*/
.ratings {
    font-size: 13px;
    color: #fff;
}

.ratings .fa {
    margin-right: 2px;
}

.ratings .fa-star {
    margin-right: 2px;
    color: #f3a90b;
}

.ratings .fa-star-o {
    color: #fff;
}

/*--------------------------------------------------------------
# Post Share
--------------------------------------------------------------*/
.post-share {
    margin-top: 130px;
}

.post-share h3 {
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 500;
    text-transform: uppercase;
    color: #757686;
    text-align: center;
}

.post-share ul {
    list-style: none;
}

.post-share ul li {
    display: flex;
    justify-content: center;
    margin-bottom: 8px;
}

.post-share .fa {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    color: #fff;
}

.post-share .fa-facebook {
    background: #4b6cd0;
}

.post-share .fa-google-plus {
    background: #f03b3b;
}

.post-share .fa-twitter {
    background: #49a7f3;
}

.post-share .fa-instagram {
    background: #bb8950;
}

.post-share .fa-thumb-tack {
    background: #f0c605;
}

@media screen and (max-width: 992px) {
    .post-share {
        margin-top: 50px;
    }

    .post-share h3 {
        text-align: left;
    }

    .post-share ul li {
        margin: 0 5px;
    }
}

/*--------------------------------------------------------------
# About Page
--------------------------------------------------------------*/
.about-page .page-header {
    /* background: url(images/courses-header.jpg) no-repeat center; */
}

.about-heading,
.team-heading {
    margin-top: 80px;
    text-align: center;
}

.about-heading h2,
.team-heading h2 {
    font-size: 42px;
    font-weight: 400;
    color: #383749;
}

.about-heading p,
.team-heading p {
    margin-top: 20px;
    color: #757686;
}

.about-stories,
.about-values {
    color: #757686;
}

.about-stories h3,
.about-values h3 {
    margin-top: 48px;
    font-size: 24px;
    font-weight: 400;
    color: #383749;
}

.about-stories p,
.about-values p {
    line-height: 1.6;
}

.about-page .about-section {
    margin-top: 100px;
}

.about-page .testimonial-section {
    border-bottom: 1px solid #ebebeb;
}

.team-heading {
    text-align: center;
}

.team-member {
    padding: 32px 40px;
    margin-top: 48px;
    border: 1px solid #ebebeb;
    text-align: center;
    transition: all .35s;
}

.team-member:hover {
    box-shadow: 0 0 38px rgba(81, 107, 117, .21);
}

.team-member img {
    width: 180px;
    max-width: 100%;
    border-radius: 50%;
}

.team-member h3 {
    margin-top: 24px;
    font-size: 20px;
    font-weight: 400;
    color: #383749;
}

.team-member h4 {
    font-size: 16px;
    font-weight: 400;
    color: #19c880;
}

.team-member ul {
    margin-top: 24px !important;
    list-style: none;
}

.team-member ul li {
    margin: 0 10px;
}

.team-member ul li a {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    border: 1px solid #ebebeb;
    border-radius: 50%;
    text-decoration: none;
    transition: all .35s;
}

.team-member ul li .fa {
    font-size: 18px;
    font-family: 'FontAwesome';
    color: #c0c1cd;
}

.team-member ul li a:hover {
    border-color: transparent;
    background: #19c880;
}

.team-member ul li a:hover .fa {
    color: #fff;
}

/*--------------------------------------------------------------
# Blog Page
--------------------------------------------------------------*/
.blog-page .page-header {
    /* background: url("images/courses-header.jpg") no-repeat center; */
}

.blog-posts {
    margin-top: 50px;
}

.blog-post-content {
    margin-bottom: 30px;
}

.blog-post-content .blog-post-thumbnail img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.blog-post-content .posted-date {
    bottom: 0;
    left: 0;
    padding: 8px 16px;
    background: #f3a90b;
    color: #fff;
    line-height: 1;
    text-align: center;
}

.blog-post-content .posted-date .day {
    font-size: 36px;
    font-weight: bold;
}

.blog-post-content .posted-date .month {
    margin-top: 4px;
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.1em;
}

.blog-post-content-wrap .entry-title {
    margin: 24px 0 0;
    font-size: 24px;
    line-height: 1.4;
    font-weight: 400;
}

.blog-post-content-wrap .post-author {
    margin-top: 12px;
}

.blog-post-content-wrap .post-author a {
    font-style: italic;
    color: #19c880;
    text-decoration: none;
}

.blog-post-content-wrap .post-comments {
    position: relative;
    padding-left: 12px;
    margin-top: 12px;
    margin-left: 5px;
}

.blog-post-content-wrap .post-comments a {
    text-decoration: none;
    color: #757686;
}

.blog-post-content-wrap .post-comments::before {
    content: '/';
    position: absolute;
    top: 0;
    left: 0;
    width: 10px;
    text-align: center;
}

.blog-post-content-wrap .entry-content {
    margin-top: 12px;
    margin-bottom: 0;
    color: #757686;
}

/*--------------------------------------------------------------
# Single Blog Post
--------------------------------------------------------------*/
.single-blog-post .page-header {
    /* background: url("images/single-courses-bg.jpg") no-repeat center; */
}

.single-blog-post .page-header-overlay {
    height: 530px;
}

.single-blog-post .page-header .post-author a {
    font-style: italic;
    color: #19c880;
    text-decoration: none;
}

.single-blog-post .page-header .post-comments {
    position: relative;
    padding-left: 12px;
    margin-left: 5px;
}

.single-blog-post .page-header .post-comments::before {
    content: '/';
    position: absolute;
    top: 0;
    left: 0;
    width: 10px;
    text-align: center;
    color: #fff;
}

.single-blog-post .page-header .post-comments a {
    text-decoration: none;
    color: #fff;
}

.single-blog-post .featured-image {
    position: relative;
    margin-top: -80px;
    box-shadow: 0 24px 38px rgba(81, 107, 117, .21);
}

.single-blog-post .featured-image img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.single-blog-post .featured-image .posted-date {
    bottom: 0;
    left: 0;
    padding: 10px 16px;
    background: #f3a90b;
    color: #fff;
    line-height: 1;
    text-align: center;
}

.single-blog-post .featured-image .posted-date .day {
    font-size: 48px;
    font-weight: bold;
}

.single-blog-post .featured-image .posted-date .month {
    margin-top: 4px;
    font-size: 18px;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.1em;
}

.single-post-wrap {
    padding-bottom: 24px;
    margin-top: 50px;
    border-bottom: 1px solid #ebebeb;
    color: #757686;
}

.single-post-wrap blockquote {
    position: relative;
    padding-left: 68px;
    margin-top: 24px;
    margin-bottom: 32px;
    font-size: 20px;
    font-weight: 300;
    color: #383749;
}

.single-post-wrap blockquote::before {
    content: '';
    position: absolute;
    top: 10px;
    left: 0;
    width: 26px;
    height: 20px;
    /* background: url("images/quote.png") no-repeat; */
}

.single-post-wrap blockquote span {
    display: block;
    margin-top: 10px;
    font-size: 16px;
    font-weight: 500;
    color: #19c880;
}

.single-post-wrap img {
    max-width: 100%;
}

.single-post-wrap h3 {
    font-size: 24px;
    font-weight: 400;
    color: #383749;
}

.tags-links ul {
    list-style: none;
}

.tags-links li {
    margin-right: 10px;
}

.tags-links li a {
    display: block;
    padding: 10px 24px;
    font-size: 12px;
    line-height: 1;
    color: #595959;
    text-transform: uppercase;
    background: #f3f3f3;
}

@media screen and (max-width: 992px) {
    .single-blog-post .featured-image {
        margin-top: 80px;
    }
}

.related-blog-posts {
    margin-top: 50px;
}

.related-blog-posts .entry-heading {
    padding-bottom: 16px;
    border-bottom: 1px solid #ebebeb;
}

.related-blog-posts .entry-heading h2 {
    font-size: 24px;
    font-weight: 400;
    color: #383749;
}

.related-blog-posts .entry-heading a {
    color: #19c880;
    text-decoration: underline;
}

.related-blog-posts .blog-post-content {
    margin-top: 50px;
}

.author-box {
    padding-top: 60px;
    margin-top: 60px;
    border-top: 1px solid #ebebeb;
}

.author-avatar {
    width: 160px;
    margin-right: 30px;
}

.author-avatar img {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    border: 1px solid #ebebeb;
}

ul.author-social-profile {
    list-style: none;
}

ul.author-social-profile li {
    margin: 0 10px;
}

ul.author-social-profile .fa {
    font-size: 18px;
    font-family: 'FontAwesome';
    color: #c0c1cd;
}

ul.author-social-profile li:hover .fa {
    color: #19c880;
}

.author-details {
    width: calc(100% - 190px);
}

@media screen and (max-width: 576px) {
    .author-details {
        width: 100%;
        margin-top: 32px;
    }
}

.author-details h3 {
    font-size: 16px;
    font-weight: 400;
    text-transform: uppercase;
    color: #19c880;
}

.author-details h3 span {
    display: block;
    margin-top: 6px;
    text-transform: capitalize;
    color: #c0c1cd;
}

.author-details p {
    color: #757686;
    line-height: 1.8;
}

/*
# Comments
--------------------------------*/
.post-comments-wrap .post-comments {
    margin-top: 40px;
    padding-top: 50px;
    padding-bottom: 50px;
    border-top: 1px solid #ebebeb;
    border-bottom: 1px solid #ebebeb;
}

.comments-title,
.comment-reply-title {
    margin-bottom: 0;
    font-size: 24px;
    font-weight: 400;
    color: #383749;
}

.post-comments-wrap .comment-list {
    padding: 0;
    margin: 0;
    list-style: none
}

.post-comments-wrap .comment-author-avatar {
    float: left;
    width: 70px;
    height: 70px;
    margin-top: 36px;
    margin-right: 22px;
    margin-bottom: 0;
    border-radius: 50%;
    overflow: hidden;
}

.post-comments-wrap .comment-author-avatar img {
    width: 100%;
    height: auto;
}

.post-comments-wrap .comment-wrap {
    float: right;
    width: calc(100% - 92px);
    margin-top: 32px;
}

.post-comments-wrap .comment-author .fn {
    display: block;
    margin-top: 4px;
}

.post-comments-wrap .comment-author .fn a {
    font-size: 18px;
    color: #383749;
}

.post-comments-wrap .comment-author .comment-meta a {
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    color: #19c880;
}

.post-comments-wrap p {
    margin-top: 5px;
    color: #757686;
}

.post-comments-wrap .reply {
    margin-top: 8px;
}

.post-comments-wrap .reply a {
    display: inline-block;
    padding: 8px 18px;
    margin-right: 10px;
    border: 1px solid #d2d2d4;
    border-radius: 2px;
    font-size: 12px;
    font-weight: 500;
    line-height: 1;
    color: #383749;
    text-transform: uppercase;
    text-decoration: none;
    letter-spacing: 1px;
}

.post-comments-wrap .reply a:hover {
    border-color: transparent;
    color: #fff;
    background: #19c880;
}

.post-comments-wrap ol.children {
    padding: 0;
    margin-left: 92px;
    list-style: none;
}

.post-comments-wrap ol.children .comment-author-avatar {
    margin-top: 40px;
    margin-right: 22px;
}

.post-comments-wrap ol.children .comment-wrap {
    margin-top: 36px;
    width: calc(100% - 92px);
}

/*
# Comment Form
--------------------------------*/
.comments-form {
    margin-top: 50px;
}

.comment-reply-title {
    margin-bottom: 16px;
}

.comment-form input[type="text"],
.comment-form input[type="email"],
.comment-form input[type="url"],
.comment-form textarea {
    width: 100%;
    padding: 14px 24px;
    margin-top: 20px;
    border: 1px solid #e5e5e5;
    line-height: 1;
    color: #383749;
    outline: none;
}

.comment-form input[type="text"]::placeholder,
.comment-form input[type="email"]::placeholder,
.comment-form input[type="url"]::placeholder,
.comment-form textarea::placeholder {
    color: #c0c1cd;
}

.comment-form textarea {
    line-height: 1.4;
}

.comment-form input[type="text"]:focus,
.comment-form input[type="email"]:focus,
.comment-form input[type="url"]:focus,
.comment-form textarea:focus {
    border-color: #19c880;
}

.comment-form input[type="submit"] {
    padding: 16px 32px;
    margin-top: 40px;
    margin-bottom: 10px;
    border: 0;
    border-radius: 2px;
    font-size: 13px;
    font-weight: 600;
    line-height: 1;
    color: #fff;
    text-transform: uppercase;
    text-decoration: none;
    letter-spacing: 0.1rem;
    outline: none;
    cursor: pointer;
    background: #19c880;
}

/*--------------------------------------------------------------
# Contact Page
--------------------------------------------------------------*/
.contact-page .page-header {
    /* background: url(images/courses-header.jpg) no-repeat center; */
}

.contact-page .contact-gmap {
    margin-top: 60px;
    box-shadow: 0 24px 38px rgba(81, 107, 117, .21);
}

.contact-page .contact-gmap iframe {
    display: block;
    width: 100%;
    height: 540px;
}

.contact-form,
.contact-info {
    margin-top: 80px;
}

.contact-form h3,
.contact-info h3 {
    margin-bottom: 12px;
    font-size: 36px;
    font-weight: 400;
    color: #383749;
}

.contact-form input[type="text"],
.contact-form input[type="email"],
.contact-form textarea {
    width: 100%;
    padding: 12px 20px;
    margin-top: 18px;
    border: 1px solid #ebebeb;
    background: #f7f7f7;
    color: #383749;
}

.contact-form input[type="text"]:focus,
.contact-form input[type="email"]:focus,
.contact-form textarea:focus {
    outline: none;
}

.contact-form input[type="text"]::placeholder,
.contact-form input[type="email"]::placeholder,
.contact-form textarea::placeholder {
    color: #c0c1cd;
}

.contact-form input[type="submit"] {
    padding: 16px 32px;
    margin-top: 40px;
    margin-bottom: 10px;
    border: 0;
    border-radius: 2px;
    font-size: 13px;
    font-weight: 600;
    line-height: 1;
    color: #fff;
    text-transform: uppercase;
    text-decoration: none;
    letter-spacing: 0.1rem;
    outline: none;
    cursor: pointer;
    background: #19c880;
}

.contact-info p {
    margin-top: 24px;
    line-height: 1.8;
    color: #757686;
}

.contact-info ul {
    list-style: none;
}

.contact-info li {
    margin-top: 32px;
    font-size: 24px;
    color: #383749;
}

.contact-info li span {
    display: block;
    font-size: 18px;
    color: #c0c1cd;
}

.contact-info li a {
    color: #636363;
    -webkit-text-decoration: navajowhite;
            text-decoration: navajowhite;
}

@media screen and (min-width: 992px) {
    .contact-form {
        padding-right: 40px;
    }

    .contact-info {
        padding-left: 40px;
    }
}

/*--------------------------------------------------------------
# Footer
--------------------------------------------------------------*/
.footer-widgets {
    padding: 35px 0;
    color: #fff;
    background-color: #c62829;
}

.foot-about p {
    margin-top: 40px;
    font-size: 16px;
    line-height: 1.6;
    color: #757686;
}

p.footer-copyright {
    color: #c0c1cd;
}

.footer-widgets h2 {
    margin-bottom: 40px;
    font-size: 33px;
    color: #fff;
    border-bottom: 0.0675rem solid #fff;
    padding-bottom: 1.5rem;
}

.footer-widgets ul {
    padding: 0;
    margin: 0;
    list-style: none;
}

.footer-widgets ul li {
    margin-bottom: 0.5rem;
    text-transform: uppercase;
    font-size: 13px;
}

.footer-widgets ul li a {
    color: #fff;
    text-decoration: none;
    font-size: 13px;
}

.footer-widgets ul li a:hover {
    color: #000;
}

.footer-widgets .follow-us .fa {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 10px;
    color: #fff;
}

.footer-widgets .follow-us .fa-facebook {
    background: #4b6cd0;
}

.footer-widgets .follow-us .fa-google-plus {
    background: #f03b3b;
}

.footer-widgets .follow-us .fa-instagram {
    background: #bb8950;
}

.footer-widgets .follow-us .fa-twitter {
    background: #49a7f3;
}

.footer-bar {
    padding: 30px 0;
    border-top: 1px solid #ebebeb;
}

.footer-bar .download-apps a {
    display: block;
    margin-right: 10px;
}

.footer-bar .download-apps a img {
    display: block;
}

.footer-bar-nav ul {
    padding: 0;
    margin: 0;
    list-style: none;
}

.footer-bar-nav ul li {
    margin-left: 30px;
}

@media screen and (max-width: 992px) {
    .footer-bar-nav ul li {
        margin-left: 15px;
        margin-right: 15px;
    }
}

.footer-bar-nav ul li a {
    color: #757686;
    text-decoration: none;
}

.footer-bar-nav ul li a:hover {
    color: #34d986;
}

.img-fluid {
    height: auto;
    max-width: 60%;
}

.inner-header .img-fluid {
    height: auto;
    max-width: 65%;
}

.inner-header .login_image {
    height: auto;
    max-width: 92%;
}


.btn-outline-primary {
    border-color: #c62829 !important;
    border: 1px solid #c62829 !important;
    color: #000;
    border-radius: 0;
}

.btn-primary {
    background-color: #c62829 !important;
    border-color: #c62829 !important;
    border: 1px solid #c62829 !important;
    border-radius: 0;
}

.btn-icon-text {
    width: 156px;
    height: 32px;
    font-size: 13px;
}

.btn-primary:hover {
    color: #fff;
    background-color: #c62829 !important;
    border-color: #c62829 !important;
    border: 1px solid #c62829 !important;
}

.btn-outline-primary:hover {
    color: #fff;
    background-color: #c62829 !important;
    border-color: #c62829 !important;
    border: 1px solid #c62829 !important;
}

.btn-default {
    height: 32px;
    background-color: transparent;
}

.main-img {
    position: relative;
    width: 100%;
    max-width: 672px;
}

.main-img img {
    width: 100%;
    height: auto;
}

.main-img .btn-menu {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    background-color: #EF7F1A;
    color: white;
    font-size: 18px;
    border: none;
    cursor: pointer;
    border-radius: 0px;
    text-align: center;
    width: 198px;
    height: 40px;
}

.main-img .btn-menu:hover {
    background-color: black;
}

.main-img .btn-products {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    background-color: #c62829;
    color: white;
    font-size: 18px;
    border: none;
    cursor: pointer;
    border-radius: 0px;
    text-align: center;
    width: 198px;
    height: 40px;
}

.main-img .btn-products:hover {
    background-color: black;
}

.container-fluid {
    padding-right: 0;
    padding-left: 0;
}

.main-img-text {
    font-size: 18px;
    color: #363636;
    text-align: center;
}

.price {
    font-size: 25px;
    color: #c62829;
}


.service-btn {
    background-color: #9D9E9E;
    color: #fff;
    width: 163px;
    height: 40px;
    font-size: 15px;
}

footer .contact-icons {
    font-size: 22px;
    text-transform: uppercase;
}

.list-group {
    flex-direction: row;
}

.list-group-horizontal .list-group-item {
    display: inline-block;
}

.list-group-horizontal .list-group-item {
    margin-bottom: 0;
    margin-left: -4px;
    margin-right: 0;
    border-right-width: 0;
}

.list-group-horizontal .list-group-item:first-child {
    border-top-right-radius: 0;
    border-bottom-left-radius: 0px;
}

.list-group-horizontal .list-group-item:last-child {
    border-top-right-radius: 0px;
    border-bottom-left-radius: 0;
    border-right-width: 1px;
}

.list-group-item {
    position: relative;
    display: block;
    padding: 0.5rem 1.25rem;
    margin-bottom: -1px;
    border: 1px solid #fff !important;
    background-color: transparent !important;
}

.list-group-item:first-child {
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
}

.list-group-item:last-child {
    margin-bottom: 0;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
}

.e-menu-img {
    /* background-image: url("./images/e-menu.png"); */
    background-color: #cccccc;
    background-size: cover;
    background-repeat: no-repeat;
    display: block;
    height: 650px;
}

.e-menu-img .btn-menu {
    position: absolute;
    top: 22%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    background-color: #EF7F1A;
    color: white;
    font-size: 18px;
    border: none;
    cursor: pointer;
    border-radius: 0px;
    text-align: center;
    width: 198px;
    height: 40px;
}

.e-menu-img .btn-menu:hover {
    background-color: black;
}

.e-products-img {
    /* background-image: url("./images/my-products.png"); */
    background-color: #cccccc;
    background-size: cover;
    background-repeat: no-repeat;
    display: block;
    height: 650px;
}

@media screen and (max-width: 992px) {
    .e-products-img {
        height: 600px;
    }

    .e-menu-img {
        height: 600px;
    }

    .e-menu-img .btn-menu {
        top: 22% !important;
    }

    .e-products-img .btn-products {
        top: 22% !important;
    }
}

.e-products-img .btn-products {
    position: absolute;
    top: 22%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    background-color: #c62829;
    color: white;
    font-size: 18px;
    border: none;
    cursor: pointer;
    border-radius: 0px;
    text-align: center;
    width: 198px;
    height: 40px;
}

.e-products-img .btn-products:hover {
    background-color: black;
}

.header-image {
    height: 260px;
    width: 100%;
}

.cont-bg {
    background-color: #f5f5f5;
    padding-top: 3rem;
    padding-bottom: 3rem
}

.register-page .page-header {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
    height: 260px;
}

.register-page .login_image {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center;
    height: 260px;
}

.register-page .register_image {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center;
    height: 260px;
}

.register-page .card {
    border-radius: 0;
    border: 0;
}

.register-page .card .form-heading {
    background-color: #c62829;
    border-radius: 4px;
    color: #fff;
    margin-bottom: 34px;
    padding: 6px 15px;
    font-size: 16px;
}



.register-page .card .accord-heading {
    background-color: #c62829;
    border-radius: 4px;
    color: #fff;
}

.register-page .card .form-heading {
    font-size: 16px;
}

.register-page .card-body {
    padding: 20px 20px 20px 20px;
}

.regpage .auth-content form .form-group {
    margin-bottom: 15px;
}

.form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    appearance: none;
    border-radius: 0.375rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

select {
    word-wrap: normal;
}

.form-select {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    /* -webkit-appearance: none;
    -moz-appearance: none;
    appearance: auto; */
    border-radius: 0.375rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.btn-danger {
    background-color: #c62829;
    font-weight: bold;
    /* font-size: 20px; */
}

.plan .columns {
    width: 50%;
    padding: 8px;
}

.plan .price {
    list-style-type: none;
    border: 1px solid #c62829;
    margin: 0;
    padding: 0;
    transition: 0.3s;
}

.plan .price:hover {
    box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.2)
}

.plan .price .header {
    background-color: #111;
    color: white;
    font-size: 16px;
}

.plan .price li {
    border-bottom: 1px solid #eee;
    padding: 10px;
    text-align: center;
}

.plan .price .grey {
    background-color: #eee;
    font-size: 25px;
    color: #c62829;
}

.plan .button {
    background-color: #EF7F1A;
    border: none;
    color: white;
    padding: 6px 25px;
    text-align: center;
    text-decoration: none;
    font-size: 18px;
    font-weight: 400;
    border-radius: 0.25rem;
}

.plan .price {
    font-size: 16px;
    color: #383749;
}

.columns {
    width: 65%;
}

@media only screen and (max-width: 600px) {
    .columns {
        width: 80%;
    }
}

.country-list {
    margin-bottom: 1rem;
    border: unset;
    width: 157px;
    appearance: none !important;
    -webkit-appearance: none !important;
    border-left: 1px solid #ccc;
    border-radius: 0;
    float: right;
}

.site-navigation .form-select {
    background-image: unset !important;
}

.modal {
    display: none;
    /* Hidden by default */
    position: fixed;
    /* Stay in place */
    z-index: 1;
    /* Sit on top */
    padding-top: 100px;
    /* Location of the box */
    left: 0;
    top: 0;
    width: 100%;
    /* Full width */
    height: 100%;
    /* Full height */
    overflow: auto;
    /* Enable scroll if needed */
    background-color: rgb(0, 0, 0);
    /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4);
    /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
    background-color: #fefefe;
    margin: auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
}

/* The Close Button */
.close {
    color: #aaaaaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
}

.save {
    padding: 6px 25px;
}

.cuisine .card {
    align-items: center;
    border: 1px solid #bfc1c1;
    border-radius: 3px;
    box-shadow: 4px 4px 4px rgba(0, 0, 0, .2);
    height: 120px;
    margin-bottom: 2rem;
    margin-top: 2rem;
    width: 120px;
}


.cuisine .card:hover {
    border: 2px solid #c62829;
    cursor: pointer;
}

.cuisine .card .card-img {
    height: 40px;
    width: auto;
    margin-top: 15px;
}

.cuisine .card-text {
    font-size: 13px;
    color: #252525;
    text-align: center;
}

.cuisine .card-body {
    padding: 15px 10px 10px 10px;
    line-height: 1.5;
}

.cuisine {
    margin-bottom: 2rem;
}

.cuisine .col {
    flex-grow: 0;
    padding-left: 20px;
    padding-right: 20px;
}

.img-responsive {
    display: block;
    max-width: 100%;
    height: auto;
}



.menu-card .card .container {
    border: 2px solid #889F2C;
    margin-top: -12px;
    padding: 25px;
}

.menu-card .card .templete3 .container {
    border: 0;
}

.menu-card .card .container h6 {
    text-transform: uppercase;
    color: #545454;
}

.menu-card p {
    line-height: 1.4;
    font-size: 12px;
    color: #878787;
}

@media only screen and (max-width: 767px) {
    .menu-card .card {
        width: auto;
    }
}

.menu-card .img {
    padding: 0 0 1rem 0;
}

.design .card {
    border: 1px solid #BFC1C1;
    border-radius: 3px;
    margin-bottom: 2rem;
    display: block;
    padding: 2rem 1rem;
    height: 512px;
}

.design .card img {
    border: 1px solid #BFC1C1;
    border-radius: 3px;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%);
}

.design .card-body {
    text-align: left;
    padding: inherit !important;
}

.design ul li {
    color: red;
}

.design ul {
    height: 135px;
}

.text-black {
    color: #383749;
}

.design .form-check .form-check-input {
    height: 30px;
    width: 30px;
    margin-left: 1.3rem;
}

.qrcode .card {
    border: 1px solid #BFC1C1;
    height: 290px;
    text-align: center;
    display: block !important;
    box-shadow: unset !important;
    padding: 0 !important;
    width: auto !important;
}

.qrcode .card img {
    width: 133px;
    text-align: center;
}

.qrcode h3 {
    padding: 1rem 0;
    font-size: 25px;
}

.payment-btn {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    display: block;
}

.btn-secondary {
    background-color: #EF7F1A;
    padding: 6px 25px;
    border-color: transparent;
}

.fa-caret-up {
    font-size: 1.7rem;
}

.fa-caret-down {
    font-size: 1.7rem;
    margin-left: 5px;
}

.fa-pencil-square {
    font-size: 1.3rem;
    margin-left: 8px;
    color: #9D9F9E;
}

.fa-times-circle {
    font-size: 1.3rem;
    margin-left: 8px;
    color: #C62829;
}

.seemore {
    position: absolute;
    top: 24.7%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    color: white;
    font-size: 16px;
    border: none;
    cursor: pointer;
    text-align: center;
}

.login .card {
    width: 60%;
}

/* #updateServices .login .card {
    width: 30%;
} */


@media only screen and (max-width: 767px) {
    .login .card {
        width: auto;
    }
}

.postlogin .page-header {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center !important;
    height: 260px;
}

.service .columns {
    width: 80%;
}

@media only screen and (max-width: 600px) {
    .service .columns {
        width: 90%;
    }
}

@media only screen and (max-width: 991px) {
    .img-fluid {
        height: auto;
        max-width: 90%;
    }
}



@media only screen and (max-width: 793px) {
    .img-fluid {
        height: auto;
        max-width: 70%;
    }
}

@media only screen and (max-width: 574px) {
    .img-fluid {
        height: auto;
        max-width: 50%;
    }
}

.edit-profile-img img {
    width: auto;
    height: 60px;
}

@media (min-width: 576px) {
    .dashboard .card-columns {
        display: flex;
    }
}

.dashboard .card-columns .card {
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%);
    align-items: center;
    border: 0;
    border-radius: 8px;
    margin-top: 1rem;
    margin-bottom: 5rem;
    background-color: #fff;
}

.dashboard .card-columns .card .card-text {
    font-weight: 500;
    font-size: 18px;
    margin-bottom: 0.5rem;
}

.dashboard .card-columns .card .card-title {
    margin-bottom: 0.75rem;
    color: #c62829;
}

.dashboard .card-columns .card .fa {
    color: #e5e5e5;
    padding: 5px;
    border-radius: 3px;
}

.dashboard .card-columns .card .card-body {
    padding: 20px;
}

.dashboard a:visited {
    /* color: #383749; */
    text-decoration: underline;
}

.text-orange {
    color: #EF7F1A !important;
}

.text-black {
    color: #383749 !important;
}


.url {
    background: #EF7F1A;
    padding: 0 8px;
    color: #fff;
    font-size: 13px;
    justify-content: space-between;
    margin: 0 4px;
    line-height: 1.4;
    margin-bottom: 25px !important;
}

.url a:visited {
    color: #fff;
}

.text-sm {
    font-size: 0.8rem;
    color: #000000;
}

.select-box .form-select {
    display: block;
    /* padding: unset !important; */
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-color: #fff;
    background-clip: padding-box;
    border: 0.5px solid black !important;
    /* appearance: auto; */
    border-radius: unset !important;
    transition: unset !important;
    width: 156px;
    height: 32px;
    font-size: 13px;
    text-align: left !important;
}


.form-control {
    /* appearance: auto; */
}

.fa {
    margin-right: 5px;
}

.modal-header .btn-close {
    padding: calc(var(--bs-modal-header-padding-y)*0.5) calc(var(--bs-modal-header-padding-x)*0.5);
    margin: calc(-0.5*var(--bs-modal-header-padding-y)) calc(-0.5*var(--bs-modal-header-padding-x)) calc(-0.5*var(--bs-modal-header-padding-y)) auto;
}

[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled),
button:not(:disabled) {
    cursor: pointer;
}

.btn-close {
    box-sizing: content-box;
    width: 1em;
    height: 1em;
    padding: 0.25em;
    color: #000;
    background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_3___}) 50%/1em auto no-repeat;
    border: 0;
    border-radius: 0.375rem;
    opacity: .5;
}

.cuisine .border-card {
    border: 2px solid #c62829;
}



.react-select__control {
    border-color: unset !important;
    border-radius: unset !important;
    border-style: unset !important;
    border-width: unset !important;
    box-sizing: border-box;
    width: 110px !important;
    float: right !important;
}

.react-select__indicator {
    display: none !important;

}

.react-select__indicator span {
    display: none !important;
}


.react-select__option .country-option {
    margin-right: 5px !important;
}

.searchSet {
    margin-top: -10px;
    float: right;
    display: flex;
}

#react-select-2-listbox {
    width: 138px !important;
    margin-left: 175px !important;
}


.clearButton {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    height: 34px;
    width: 32px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}

.react-select__menu-list {
    overflow-y: hidden !important;
    max-height: 389px !important;
}

.menu-card .card {
    border: 0;
    border-radius: 0;
    box-shadow: unset;
    padding: 0;
    display: block;
}

.card-img-overlay .card {
    border: 1px solid #eeeeee;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, .2), 0 6px 20px 0 rgba(0, 0, 0, .19);
    margin-bottom: 0.5rem;
    width: 90% !important;
    padding: 11px;
}

/*.card-img-overlay .cardHeight {
    height: 448px !important;
}*/

.card-img-overlay .temp-3 {
    border: 0 !important;
}

.page-wrapper {
    width: 595px;
    height: 842px;
}

.card-img-overlay .card img {
    width: -webkit-fill-available;
    max-height: 295px;
    min-height: auto;
    height: 295px;
    width: -moz-available;
}

.card-img-overlay .card .container {
    border: 0 !important;
    padding: 15px 10px !important;
}

.card-img-overlay .card .container h4 {
    font-size: 1 rem !important;
}

.card-img-overlay p {
    line-height: 1;
}

.menu-card .card .container {
    border: 2px solid #889F2C;
    padding: 25px;
}

.menu-card .card .container h6 {
    text-transform: uppercase;
    color: #545454;
}

.menu-card .desc {
    line-height: 1;
    font-size: 16px;
    color: #878787;
    display: flex !important;
    justify-content: center !important;
    margin-top: 10px;
    margin-bottom: 5px;
    margin-top: 5px;
}


.templete3 .desc {
    justify-content: left !important;
}




.menu-card .price {
    line-height: 1.4;
    font-size: 18px;
    color: #fff;
    background: #c62829;
    padding: 1px 5px;
    font-weight: bold;
}


.menu-card .price1 {
    line-height: 1.4;
    font-size: 18px;
    color: #fff;
    background: #c62829;
    padding: 1px 5px;
    font-weight: bold;
    float: left !important;
}



.menu-card .logo {
    height: 60px;
    margin-bottom: 10px;
    width: auto;
}

.menu-card p {
    line-height: 1.4;
    font-size: 1rem;
    color: #c62829;
    border: 1px solid #c62829;
    border-style: dashed;
    padding: 0.2rem;
    margin: 20px 0px 15px 0px;
}

@media only screen and (max-width: 767px) {
    .menu-card .card {
        width: auto;
    }

    .menu-card h2 {
        font-size: 1rem;
    }
}

.menu-card .img {
    padding: 0 0 1rem 0;
}

.menu-card h2 {
    color: #c62829;
    font-size: 2.5rem;
}

.menu-card h3 {
    margin: 1rem 0 0 0;
}

.card-img-overlay {
    background-size: cover;
    background-repeat: no-repeat;
    display: block;
    position: inherit;
}

/* .american_cuisine {
  background-image: url("../images/American_cuisine.png");
  } */

.address {
    background: #ccc;
    padding: 2px 8px;
    font-size: 13px;
    justify-content: space-between;
    margin: 0 -15px;
    line-height: 1.4;
}

.card-img-overlay {
    padding-bottom: 0;
}

.text-orange {
    color: #EF7F1A !important;
}

.text-black {
    color: #383749 !important;
}

.url {
    background: #EF7F1A;
    padding: 0 8px;
    color: #fff;
    font-size: 1.5rem;
    justify-content: space-between;
    margin: 0;
    line-height: 1.4;
}

.url a:visited {
    color: #fff;
}

.modal-backdrop.show {
    z-index: 999;
}

.modal-open .modal {
    z-index: 999;
}

.accordion-button {
    background-color: #c62829;
    border-radius: 4px;
    color: #fff;
    margin-bottom: 40px;
    padding: 6px 15px;
    font-size: 16px;
}

.accordion-header h4 {
    font-size: 16px;
    margin-bottom: 0;
}

.accordion-button:not(.collapsed) {
    background-color: #c62829;
    border-radius: 4px;
    color: #fff;
    margin-bottom: 40px;
    padding: 6px 15px;
    font-size: 16px;
}

.accordion-button:focus {
    border-color: #c62829;
    box-shadow: unset;
}

.seemore {
    position: absolute;
    top: 24.7%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 16px;
    border: none;
    cursor: pointer;
    text-align: center;
}




/* PDF Ganrate */
.invoice-box {
    max-width: 95%;
    margin: auto;
    padding: 0 10px 10px 10px;
    font-size: 16px;
    line-height: 24px;
    font-family: Arial;
    color: #555;
    border: 1px solid #ccc;
}


.invoice-box .title img {
    width: 300px;
    border-top: 15px solid #EF7F1A;
}


.logoPreview {
    height: 50px;
    width: 62px;
}

.item-image {
    width: 150px;
    height: 150px;
}


.invoice-box table {
    width: 100%;
    line-height: inherit;
    text-align: left;
}

.invoice-box table td {
    padding: 5px;
    vertical-align: top;
}

.invoice-box table tr td:nth-child(7) {
    text-align: center;
}

.invoice-box table tr td:nth-child(5) {
    text-align: center;
}

.invoice-box table tr td:nth-child(6) {
    text-align: center;
}

.invoice-box table tr.top table td {
    padding-bottom: 20px;
}

.invoice-box table tr.top table td.title {
    text-align: center;
}

.inv {
    font-size: 55px;
    line-height: 45px;
    color: #60CAFF;
    text-align: center;
}

.invoice-box table tr.information table td {
    padding-bottom: 10px;
    width: 300px;
}

.invoice-box table tr.information table td.sub-title {
    font-size: 24px;
    color: #030303;
    font-family: roboto;
}

.invoice-box table tr.information table td.billto {
    color: #fff;
    background: #6ACEFF;
    width: 300px;
    padding-bottom: 10px !important;
}

.invoice-box table tr.heading td {
    border-bottom: 1px solid #ccc;
    font-weight: bold;
    text-align: center;
}

.invoice-box table tr.heading-blue td {
    background: #fff;
    border-bottom: 1px solid #ccc;
    font-weight: bold;
    color: #000;
    border-top: 1px solid #ccc;
}

.invoice-box table tr.details td {
    padding-bottom: 20px;
    border-bottom: 1px solid #ccc;
}

.invoice-box table tr.item td {
    border-bottom: 1px solid #eee;
}

.invoice-box table tr.item.last td {
    border-bottom: none;
}

.invoice-box table tr.total td:nth-child(2) {
    border-top: 2px solid #eee;
    font-weight: bold;
}

.td-border {
    border: 1px solid #6ACEFF;
}

@media only screen and (max-width: 600px) {
    .invoice-box table tr.top table td {
        width: 100%;
        display: block;
        text-align: center;
    }

    .invoice-box table tr.information table td {
        width: 100%;
        display: block;
        text-align: center;
    }
}

.invoice-box table .information td strong {
    font-size: 18px;
}

.invoice-box .inv-des {
    font-size: 13px;
    font-style: italic;
    font-weight: bold;
    margin-top: -8px;
}

.invoice-box table div span {
    padding-left: 16%;
}


.invoice-box .td-border {
    border: 1px solid #6ACEFF;
}

.invoice-box .sm-text {
    line-height: 1.5;
    font-size: 13px;
    font-style: italic;
    font-weight: bold;
    margin-top: -8px;
}

.invoice-box .footer-sm-text {
    line-height: 1.5;
    font-size: 12px;
    font-weight: bold;
    margin-top: 15px;
    text-align: center;
}

.invoice-box .redline {
    border: 2px solid #c62829;
    width: 31%;
    margin-top: 80px;
    opacity: 9;
}

.redlinethick {
    border: 8px solid #c62829;
    width: 60%;
    margin-top: 40px;
    margin-bottom: 0;
    opacity: 9;
}


/** RTL **/
.invoice-box .rtl {
    direction: rtl;
    font-family: Tahoma, 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;
}

.invoice-box .rtl table {
    text-align: right;
}

.invoice-box .rtl table tr td:nth-child(2) {
    text-align: left;
}

/* end */
.menu-flags-button {
    font-size: 15px !important;
    width: 192px !important;
    float: right;
    height: 34px;
    margin-bottom: 5px;
}

@media screen and (min-width: 992px) {
    .site-navigation ul {
        position: absolute;
        top: 37px;
        left: auto;
        width: 100%;
        height: auto;
        padding: 0;
        background: #fff;
        z-index: 1000;
        overflow: auto;
    }
}

.loading-overlay {
    display: none;
    background: rgba(255, 255, 255, 0.7);
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    z-index: 9998;
    align-items: center;
    justify-content: center;
}

.loading-overlay.is-active {
    display: flex;
}

.page-wrapper .address {
    width: 98vw !important;
    position: absolute;
    bottom: 0;
}

.preview_main .image_height {
    /*height: 320px;*/
    height: 26vw;
}

.preview_main .card-img-overlay .card img {
    max-height: -webkit-fill-available;
    height: -webkit-fill-available;
}

.preview_main .menu-card .desc {
    margin-bottom: 0px;
}

@keyframes spinner-border {
    to {
        transform: rotate(360deg)
            /* rtl:ignore */
        ;
    }
}

.spinner-border {
    display: inline-block;
    width: 2rem;
    height: 2rem;
    vertical-align: -0.125em;
    border: 0.25em solid currentColor;
    border-right-color: transparent;
    border-radius: 50%;
    animation: 0.75s linear infinite spinner-border;
}

.spinner-border-sm {
    width: 1rem;
    height: 1rem;
    border-width: 0.2em;
}

.spinner-position {
    margin-top: -27px;
    float: right;
    margin-right: 10px;
}


.register-page .page-product {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center !important;
    height: 260px;
}

.register-page .inner-header {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat center;
    height: 260px;
}


/* .register-page .dashboard_img {
    background: url("../images/BANER_Dashboard.jpg") no-repeat center;
    height: 260px;
} */

.register-page .inner-header-payment {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat center;
    height: 260px;
}

.pdf_button {
    text-align: initial;
    margin-bottom: 8px;
    justify-content: space-between;
}

.downloadPdf {
    border-radius: 6px;
}


.templete3 {
    width: 100% !important;
    border: 0;
    height: auto;
    padding: 20px;
}

.templete3 .container {
    text-align: left;
    border-bottom: 1px solid #ccc !important;
    padding: 20px !important;
    /* border-style: dotted !important; */
    margin-top: 0;
}

.templete3 .price {
    float: right;
    bottom: auto;
    position: inherit;
    margin-top: -20px;
}

.set_select {
    padding-top: 1rem;
}


.image_height {
    height: 300px;
}

.text-sm-10 {
    font-size: 10px;
}

.item-h4 {
    font-size: 1rem !important;
}

.text-sm-12 {
    font-size: 12px;
}


.menu-card .quantity {
    line-height: 1.4;
    font-size: 18px;
    color: #fff;
    background: #383749;
    padding: 1px 5px;
    font-weight: 500;
    bottom: 10px;
    float: left;
    margin-left: 16px;

}

.justify-content {
    justify-content: space-between;
}

.fix_height {
    font-size: 20px;
    margin-bottom: 25px;
}

button.emenubtm {
    margin-top: -40px;
}

.cont-bg.shopping-cart-page {
    height: 100vh;
}

.pdf_button2 {
    text-align: initial;
    padding: 14px 71px 8px 72px;
    justify-content: space-between;
}

.price_unit {
    float: right;
    display: grid;
    margin-top: -90px;
}


.price_unit .price1 {
    line-height: 1.4;
    font-size: 13px;
    color: #fff;
    background: #c62829;
    padding: 4px;
    text-align: center;
    /* margin-top: -46px; */
}


.price_unit .quantity1 {
    line-height: 1.4;
    font-size: 13px;
    color: #fff;
    background: #383749;
    ;
    margin-top: 18px;
    padding: 8px;
    text-align: center;
}

.shadow {
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%);
}

.selct-temp {
    justify-content: end;
}

@media screen and (max-width: 767px) {
    .selct-temp {
        justify-content: center;
    }
}

.selct-back {
    justify-content: start;
}

@media screen and (max-width: 767px) {
    .selct-back {
        justify-content: center;
    }
}

img.restaurantLogo {
    width: 60px;
    height: auto;
}

img.cuisineImg {
    width: 30px;
    height: auto;
}

hr.linewithspace {
    margin-top: 20px;
}

td.address {
    background: white;
    font-weight: 100;
}

td.addressIcon {
    vertical-align: top;
}

a.WhiteTxt {
    color: white;
    text-decoration: none;
}

h4.card-text {
    color: #c62829;
    font-size: 20px;
}

p.emenulink {
    color: #c62829;
    font-size: 12px;
    line-height: 1.2;
}

.flags-dropdown #rfs-btn {
    margin: 0px;
    padding: 0px 10px;
    border: none;
    font-size: 16px;
}

.flags-dropdown ul {
    margin-top: 21px !important;
    padding: 0px 0px;
    max-height: 360px;
}

.ReactFlagsSelect-module_selectOptionWithlabel__2GpmM {
    padding: 2px 10px;
}

.flex-column {
    flex-direction: row !important;
}

.nav-pills {
    --bs-nav-pills-link-active-bg: #198754 !important;
}

.heder_dropdown {
    border: 1px solid #c62829;
    ;
    border-radius: unset;
    height: 32px;
    /* width: 150px; */
}


.drp_button {
    margin-top: -2px;
    border: unset;
    border-radius: unset !important;
    height: 32px;
}

.drp_button .btn:hover {
    color: unset !important;
    background-color: unset !important;
    border-color: unset !important;
}

.drp_button .btn.show {
    color: unset !important;
    background-color: unset !important;
    border-color: unset !important;
}

.item_border {
    border: 1px solid #c62829;
    ;
}

.show_drop {
    padding: 0px 0px 0px 0px;
}

h4.card-text.EProductCard {
    padding: 15px 12px;
}

select.goog-te-combo {
    padding: 12px;
    border: none;
}

.login_link {
    display: flex;
    justify-content: space-between;
}

@media screen and (max-width: 767px) {
    .login_link {
        display: block
    }
}

p.card-text.cuisinesName {
    font-size: 13px;
}

.service-ht {
    height: 60px;
}

.address-ht {
    min-height: 160px;
}

.fa-map-marker {
    font-size: 1.3rem;
}

.fa-phone {
    font-size: 1.2rem;
}

.fa-globe {
    font-size: 1.2rem;
}

.emenubtm {
    text-align: center;
    text-decoration: none;
    color: #fff !important;
}

.tickimg {
    height: 38px;
    width: 50px;
    position: block;
    /* margin-top: 54px; */
    z-index: 2;
    margin-left: -7px;
}

.cuisine {
    overflow-y: auto;
    height: 800px;
}

@media screen and (max-width: 767px) {
    .cuisine {
        height: 500px;
    }
}

.showbackPreview {
    height: 800px;

}

.bgImage {
    height: 100%;
    width: auto;
}

.navbar-dark .navbar-nav .nav-link {
    color: white;
    font-size: 1rem;
    text-align: left;
}

div#basic-navbar-nav {
    text-align: right;
    margin-right: 20px;
}

.navbar-toggler:focus {
    box-shadow: none;
}

.ancertags a {
    color: unset !important;
}

.setAncer {
    color: unset !important;
}

.visit_link:visited {
    color: #fff;
}

.pullRight {
    float: right;
}

#previewPdf .container {
    width: 100% !important;
    max-width: 100% !important;
}

.menu-card .container {
    width: 100% !important;
    max-width: 100% !important;
}

#previewPdf .address {
    background-color: #abaab;
    color: #000;
    font-size: 1.5rem;
    padding: 1rem;
}

.sec_code {
    justify-content: space-between !important;
    display: flex;
}

.select_cuisine1 {
    padding: 80px;
    text-align: center;
}



/* 
input[type="checkbox"] {
    -webkit-appearance: none;
    position: relative;
    width: 100%;
    cursor: pointer;
    z-index: 1;
  }

  input[type="checkbox"]:after {
    position: absolute;
    font-family: "Font Awesome 5 Free";
    font-weight: 400;
    content: "\\f111";
    font-size: 18px;
    color: #478bfb;
    right: 10px;
    top: -5px;
    z-index: 1;
  }
  
  input[type="checkbox"]:checked:after {
    font-weight: 900;
    content: "\\f058";
    color: #478bfb;
    z-index: 1;
  } */



input[type="checkbox"][id^="myCheckbox"] {
    display: none;
}


.mylabel {
    /* border: 1px solid #fff; */
    /* padding: 10px; */
    display: block;
    position: relative;
    /* margin: 10px; */
    cursor: pointer;
}

.mylabel:before {
    background-color: white;
    color: white;
    content: " ";
    display: block;
    border-radius: 50%;
    /* border: 1px solid grey; */
    position: absolute;
    top: -13px;
    left: 13px;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 28px;
    transition-duration: 0.4s;
    transform: scale(0);
    z-index: 1;
}

.mylabel {
    border-color: #ddd;
}

.mylabel:before {
    content: "✓";
    font-size: 35px;
    background-color: #c62829;
    transform: scale(1);
    z-index: 1;
}

.checklabel:before {
    background-color: white;
    color: white;
    content: " ";
    display: block;
    border-radius: 50%;
    /* border: 1px solid grey; */
    position: absolute;
    top: -13px;
    left: 20px;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 28px;
    transition-duration: 0.4s;
    transform: scale(0);
    z-index: 1;
}


.checklabel:before {
    border: 2px solid #ccc;
    transform: scale(1);
}


@media screen and (max-width: 767px) {
    .mobile_set {
        display: flex !important;
    }

}

@media screen and (min-width: 992px) {
    .navbar-expand-lg .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0;
    }
}

@media screen and (min-width: 991px) and (max-width: 1198px) {
    .navbar-expand-lg .navbar-nav .nav-link {
        padding-right: 0.5rem;
        font-size: 0.8rem;
    }
}

.showTranslate {
    display: none !important;
}

.switchSize {
    font-size: medium;
}



/* CSS */
.button-1 {
    background-color: #c62829;
    border-radius: 8px;
    border-style: none;
    box-sizing: border-box;
    color: #FFFFFF;
    cursor: pointer;
    display: inline-block;
    font-family: "Haas Grot Text R Web", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 14px;
    font-weight: 500;
    height: 40px;
    line-height: 20px;
    list-style: none;
    margin: 0;
    outline: none;
    padding: 10px 16px;
    position: relative;
    text-align: center;
    text-decoration: none;
    transition: color 100ms;
    vertical-align: baseline;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
}

.button-1:hover,
.button-1:focus {
    background-color: #c62829;
}

html {
    -webkit-user-select: none !important;
            user-select: none !important;
}


.btn-menu-not {
    background-color: #EF7F1A;
    color: white;
    font-size: 18px;
    border: none;
    cursor: pointer;
    border-radius: 0px;
    text-align: center;
    width: 198px;
    height: 40px;
}

.btn-products-not {
    background-color: #c62829;
    color: white;
    font-size: 18px;
    border: none;
    cursor: pointer;
    border-radius: 0px;
    text-align: center;
    width: 198px;
    height: 40px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css1/style.css"],"names":[],"mappings":"AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;;GAEG;;AAEH;;+DAE+D;AAC/D;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;IAGI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;IAEI,UAAU;IACV,gBAAgB;AACpB;;AAEA;;+DAE+D;AAC/D;IACI,wBAAwB;AAC5B;;AAEA;;+DAE+D;AAC/D;IACI,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;iCAEiC;AACjC;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA;;iCAEiC;AACjC;IACI,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;;iCAEiC;AACjC;IACI,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,cAAc;IACd,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;;IAEI;;QAEI,WAAW;IACf;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;;iCAEiC;AACjC;IACI,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;;iCAEiC;AACjC;IACI,eAAe;IACf,mCAAmC;AACvC;;AAEA;;iCAEiC;AACjC;IACI,eAAe;IACf,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,IAAI;AACR;;AAEA;;yCAEyC;AACzC;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,OAAO;IACP,4BAA4B;AAChC;;AAEA;IACI,QAAQ;AACZ;;AAEA;;IAEI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;IACT,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,QAAQ;IACR,SAAS;AACb;;AAEA;;iCAEiC;AACjC;IACI,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,MAAM;IACN,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI;QACI,kBAAkB;QAClB,SAAS;QACT,UAAU;QACV,WAAW;QACX,YAAY;QACZ,UAAU;QACV,cAAc;QACd,uBAAuB;IAC3B;AACJ;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;iCAEiC;AACjC;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;;+DAE+D;AAC/D;IACI,4DAA4D;IAC5D,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;+DAE+D;AAC/D;;iCAEiC;AACjC;IACI,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,gCAAgC;IACpC;AACJ;;AAEA;IACI;QACI,WAAW;QACX,eAAe;QACf,gCAAgC;IACpC;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;;iCAEiC;AACjC;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,eAAe;IACf,cAAc;IACd,cAAc;IACd,qBAAqB;AACzB;;AAEA;;IAEI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,WAAW;IACX,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;;iCAEiC;AACjC;;IAEI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;;;AAIA;IACI;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,aAAa;QACb,yBAAyB;QACzB,aAAa;IACjB;AACJ;;AAEA;;iCAEiC;AACjC;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;iCAEiC;AACjC;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;iCAEiC;AACjC;IACI,WAAW;AACf;;AAEA;IACI,QAAQ;IACR,WAAW;IACX,WAAW;IACX,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,SAAS;QACT,kBAAkB;IACtB;AACJ;;AAEA;;iCAEiC;AACjC;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;IAEI,6BAA6B;AACjC;;;AAGA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,WAAW;IACX,YAAY;IACZ,+DAA+D;AACnE;;AAEA;IACI,eAAe;IACf,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;iCAEiC;AACjC;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,OAAO;IACP,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;;IAEI,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;AAEJ;;AAEA;;iCAEiC;AACjC;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,4BAA4B;AAChC;;AAEA;;IAEI,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI;QACI,4BAA4B;IAChC;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,4BAA4B;IAChC;;IAEA;;QAEI,2BAA2B;QAC3B,kBAAkB;IACtB;;IAEA;QACI,4BAA4B;QAC5B,kBAAkB;IACtB;AACJ;;AAEA;;iCAEiC;AACjC;IACI,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;;+DAE+D;AAC/D;IACI,iCAAiC;AACrC;;AAEA;IACI,mEAAmE;AACvE;;AAEA;IACI,gCAAgC;IAChC,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;;+DAE+D;AAC/D;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;;+DAE+D;AAC/D;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;;IAGI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;;+DAE+D;AAC/D;IACI,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;;iCAEiC;AACjC;IACI,wBAAwB;IACxB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,aAAa;AACjB;;AAEA;;iCAEiC;AACjC;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,UAAU;IACV,YAAY;IACZ,eAAe;IACf,0BAA0B;IAC1B,cAAc;;AAElB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;iCAEiC;AACjC;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;;iCAEiC;AACjC;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;;iCAEiC;AACjC;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;;+DAE+D;AAC/D;IACI,sEAAsE;AAC1E;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,+CAA+C;AACnD;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;;iCAEiC;AACjC;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;IAGI,mBAAmB;IACnB,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,WAAW;IACX,YAAY;IACZ,eAAe;IACf,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,WAAW;IACX,YAAY;IACZ,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;;IAGI,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;AACjB;;AAEA;;IAEI,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,oCAA4B;YAA5B,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI;QACI,wBAAwB;QACxB,mBAAmB;IACvB;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;;;QAII,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,WAAW;IACf;AACJ;;AAEA;;+DAE+D;AAC/D;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;;+DAE+D;AAC/D;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;;+DAE+D;AAC/D;IACI,iEAAiE;AACrE;;AAEA;;IAEI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;;+DAE+D;AAC/D;IACI,mEAAmE;AACvE;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,OAAO;IACP,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;+DAE+D;AAC/D;IACI,sEAAsE;AAC1E;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,+CAA+C;AACnD;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,OAAO;IACP,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;IACZ,mDAAmD;AACvD;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,cAAc;IACd,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,WAAW;QACX,gBAAgB;IACpB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;;iCAEiC;AACjC;IACI,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,SAAS;IACT;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;;iCAEiC;AACjC;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;;IAII,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,cAAc;IACd,aAAa;AACjB;;AAEA;;;;IAII,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;;IAII,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,mBAAmB;AACvB;;AAEA;;+DAE+D;AAC/D;IACI,iEAAiE;AACrE;;AAEA;IACI,gBAAgB;IAChB,+CAA+C;AACnD;;AAEA;IACI,cAAc;IACd,WAAW;IACX,aAAa;AACjB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;;IAGI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,oCAA4B;YAA5B,4BAA4B;AAChC;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;;+DAE+D;AAC/D;IACI,eAAe;IACf,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,mCAAmC;IACnC,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;;AAGA;IACI,gCAAgC;IAChC,oCAAoC;IACpC,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;IAChC,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,oCAAoC;IACpC,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,oCAAoC;IACpC,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;;AAGA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,iCAAiC;IACjC,wCAAwC;AAC5C;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,kDAAkD;IAClD,yBAAyB;IACzB,sBAAsB;IACtB,4BAA4B;IAC5B,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,oCAAoC;IACpC,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uDAAuD;IACvD,yBAAyB;IACzB,sBAAsB;IACtB,4BAA4B;IAC5B,cAAc;IACd,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,oCAAoC;IACpC,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB;AACJ;;AAEA;IACI,oEAAwD;IACxD,aAAa;AACjB;;AAEA;IACI,oEAA6D;IAC7D,aAAa;AACjB;;AAEA;IACI,oEAAgE;IAChE,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;;;AAIA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,4BAA4B;IAC5B,yBAAyB;IAGzB,gBAAgB;IAChB,uBAAuB;IACvB,wEAAwE;AAC5E;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,4BAA4B;IAC5B,yBAAyB;IACzB;;uBAEmB;IACnB,uBAAuB;IACvB,wEAAwE;AAC5E;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,SAAS;IACT,UAAU;IAEV,gBAAgB;AACpB;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,2BAA2B;IAC3B,mCAAmC;IACnC,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,wBAAwB;IACxB,OAAO;IACP,MAAM;IACN,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,4BAA4B;IAC5B,8BAA8B;IAC9B,mBAAmB;IACnB,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA,kBAAkB;AAClB;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,UAAU;AACd;;AAEA,qBAAqB;AACrB;IACI,cAAc;IACd,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,WAAW;IACX,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;AAChB;;;AAGA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,YAAY;AAChB;;;;AAIA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,uEAAuE;AAC3E;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,4BAA4B;IAC5B,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,gCAAgC;IAChC,oCAAoC;IACpC,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;;GAEG;;;AAGH;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,qFAAyE;IACzE,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,cAAc;IAClB;AACJ;;;;AAIA;IACI;QACI,YAAY;QACZ,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,cAAc;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,uEAAuE;IACvE,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,mBAAmB;IACnB,cAAc;IACd,WAAW;IACX,eAAe;IACf,8BAA8B;IAC9B,aAAa;IACb,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,4BAA4B;IAC5B,oCAAoC;IACpC,sBAAsB;IACtB,+BAA+B;IAC/B,4BAA4B;IAC5B,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,2BAA2B;AAC/B;;;AAGA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,8FAA8F;IAC9F,gJAAgJ;AACpJ;;AAEA;;;;IAII,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,UAAU;IACV,WAAW;IACX,eAAe;IACf,WAAW;IACX,sFAA4X;IAC5X,SAAS;IACT,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;;;AAIA;IACI,8BAA8B;IAC9B,+BAA+B;IAC/B,8BAA8B;IAC9B,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;;AAE5B;;AAEA;IACI,wBAAwB;AAC5B;;;AAGA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,6BAA6B;AACjC;;;AAGA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,4BAA4B;IAC5B,+BAA+B;IAC/B,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,0EAA0E;IAC1E,qBAAqB;IACrB,qBAAqB;IACrB,aAAa;AACjB;;AAEA;;EAEE;;AAEF;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,wBAAwB;IACxB,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;;AAGA;IACI,gCAAgC;AACpC;;;;;AAKA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;AACrB;;;AAGA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;AAC1B;;;;AAIA;IACI,YAAY;IACZ,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,oBAAoB;IACpB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,4BAA4B;IAC5B,cAAc;IACd,iBAAiB;AACrB;;AAEA;;KAEK;;AAEL;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,gCAAgC;IAChC,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;;;;AAKA,gBAAgB;AAChB;IACI,cAAc;IACd,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,sBAAsB;AAC1B;;;AAGA;IACI,YAAY;IACZ,8BAA8B;AAClC;;;AAGA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;;AAGA;IACI,WAAW;IACX,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;IACjB,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,WAAW;QACX,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,cAAc;QACd,kBAAkB;IACtB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;AACd;;;AAGA,UAAU;AACV;IACI,cAAc;IACd,gFAAgF;AACpF;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,QAAQ;AACR;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI;QACI,kBAAkB;QAClB,SAAS;QACT,UAAU;QACV,WAAW;QACX,YAAY;QACZ,UAAU;QACV,gBAAgB;QAChB,aAAa;QACb,cAAc;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,MAAM;IACN,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAgBA;IACI;QAII;;QAEA;IACJ;AACJ;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,iCAAiC;IACjC,+BAA+B;IAC/B,kBAAkB;IAElB,+CAA+C;AACnD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;AACtB;;;AAGA;IACI,+EAAyE;IACzE,aAAa;AACjB;;AAEA;IACI,oEAAiE;IACjE,aAAa;AACjB;;;AAGA;;;GAGG;;AAEH;IACI,oEAAgE;IAChE,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI,sBAAsB;IACtB,SAAS;IACT,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,wCAAwC;IACxC,wBAAwB;IACxB,qCAAqC;IACrC,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,iBAAiB;;AAErB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;AACrB;;;AAGA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;AAC3B;;;AAGA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,mBAAmB;;IAEnB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,uEAAuE;AAC3E;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,yBAAyB;;IAEzB,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;AACtB;;;AAGA;IACI,gBAAgB;IAChB,aAAa;IACb,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,kCAAkC;IAClC,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;IACvB,kCAAkC;IAClC,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;;AAE7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;;AAEjB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,yCAAyC;IACzC,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;;;AAIA;;;;;;;;;;;;;;;;;;;;;;;;;;KA0BK;;;;AAIL;IACI,aAAa;AACjB;;;AAGA;IACI,4BAA4B;IAC5B,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,4BAA4B;IAC5B,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,4BAA4B;IAC5B,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;AACd;;;AAGA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;;AAGA;IACI;QACI,wBAAwB;IAC5B;;AAEJ;;AAEA;IACI;QACI,qBAAqB;QACrB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,iBAAiB;IACrB;AACJ;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;;;AAIA,QAAQ;AACR;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,mFAAmF;IACnF,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,uBAAuB;IACvB,wBAAwB;IACxB,iBAAiB;IACjB,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,oCAA4B;YAA5B,4BAA4B;AAChC;;;AAGA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700');\n\nbody {\n    color: #383749;\n    font-size: 15px;\n    line-height: 1.8;\n    font-family: 'Roboto', sans-serif;\n}\n\n/* img {\n    vertical-align: baseline;\n} */\n\n/*--------------------------------------------------------------\n# Links\n--------------------------------------------------------------*/\na {\n    color: #383749;\n}\n\na:visited {\n    color: #757686;\n}\n\na:hover,\na:focus,\na:active {\n    color: #383749;\n    text-decoration: none;\n}\n\na:focus {\n    outline: thin dotted;\n}\n\na:hover,\na:active {\n    outline: 0;\n    list-style: none;\n}\n\n/*--------------------------------------------------------------\n# Helper Utilities\n--------------------------------------------------------------*/\n.flex {\n    display: flex !important;\n}\n\n/*--------------------------------------------------------------\n# Site Header\n--------------------------------------------------------------*/\n.site-header {\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: auto;\n}\n\n.top-header-bar {\n    background: #fff;\n}\n\n/*\n# Header Bar Text\n--------------------------------*/\n.header-bar-text,\n.header-bar-email {\n    padding: 11px 26px;\n}\n\n.header-bar-text .fa,\n.header-bar-email .fa {\n    margin-right: 12px;\n    font-size: 20px;\n    color: #19c880;\n}\n\n.header-bar-text p {\n    margin: 0;\n}\n\n/*\n# Header Bar Email\n--------------------------------*/\n.header-bar-email {\n    padding-left: 16px;\n    border-right: 1px solid #ebebeb;\n}\n\n.header-bar-email a {\n    color: #383749;\n    text-decoration: none;\n}\n\n/*\n# Header Bar search\n--------------------------------*/\n.header-bar-search input[type=\"search\"] {\n    width: 280px;\n    padding: 12px 26px;\n    border: 0;\n    line-height: 1;\n    background: #f3f3f3;\n    color: #383749;\n}\n\n.header-bar-search input[type=\"search\"]::placeholder {\n    color: #757686;\n}\n\n.header-bar-search input[type=\"search\"]:focus {\n    outline: none;\n}\n\n.header-bar-search button[type=\"submit\"] {\n    width: 50px;\n    height: 50px;\n    border: 0;\n    color: #fff;\n    background: #19c880;\n    cursor: pointer;\n    outline: none;\n}\n\n@media screen and (max-width: 1200px) and (min-width: 992px) {\n    .header-bar-search input[type=\"search\"] {\n        width: 240px;\n    }\n}\n\n@media screen and (max-width: 576px) {\n\n    .header-bar-search,\n    .header-bar-menu {\n        width: 100%;\n    }\n\n    .header-bar-search input[type=\"search\"] {\n        width: calc(100% - 50px);\n    }\n}\n\n/*\n# Header Bar Menu\n--------------------------------*/\n.header-bar-menu ul {\n    padding: 0 16px 0 32px;\n    margin: 0;\n    list-style: none;\n}\n\n.header-bar-menu li a {\n    position: relative;\n    display: block;\n    padding: 0 6px;\n    color: #383749;\n}\n\n.header-bar-menu li a::after {\n    content: '/';\n    position: absolute;\n    top: 50%;\n    right: -3px;\n    width: 6px;\n    margin-top: -12px;\n}\n\n.header-bar-menu li:nth-last-of-type(1) a::after {\n    display: none;\n}\n\n/*\n# Nav Bar\n--------------------------------*/\n.nav-bar {\n    padding: 14px 0;\n    background: rgba(255, 255, 255, .1);\n}\n\n/*\n# Site Branding\n--------------------------------*/\n.site-title {\n    padding: 10px 0;\n    margin: 0;\n    font-size: 36px;\n    font-weight: 500;\n    line-height: 1;\n    text-align: left !important;\n}\n\n.site-title a {\n    color: #fff;\n    text-decoration: none;\n}\n\n.site-title a span {\n    color: #19c880;\n}\n\n@media screen and (min-width: 576px) {\n    /*.site-title {*/\n    /*font-size: 112px;*/\n    /*}*/\n}\n\n/*\n  Hamburger Menu\n----------------------------------------*/\n.hamburger-menu {\n    position: relative;\n    width: 24px;\n    height: 22px;\n    margin: 0 auto;\n    transition: .5s ease-in-out;\n    cursor: pointer;\n}\n\n.hamburger-menu span {\n    display: block;\n    position: absolute;\n    height: 2px;\n    width: 100%;\n    background: #fff;\n    border-radius: 10px;\n    opacity: 1;\n    left: 0;\n    transition: .25s ease-in-out;\n}\n\n.hamburger-menu span:nth-child(1) {\n    top: 2px;\n}\n\n.hamburger-menu span:nth-child(2),\n.hamburger-menu span:nth-child(3) {\n    top: 10px;\n}\n\n.hamburger-menu span:nth-child(4) {\n    top: 18px;\n}\n\n.hamburger-menu.open span:nth-child(1) {\n    top: 18px;\n    width: 0;\n    left: 50%;\n}\n\n.hamburger-menu.open span:nth-child(2) {\n    transform: rotate(45deg);\n}\n\n.hamburger-menu.open span:nth-child(3) {\n    transform: rotate(-45deg);\n}\n\n.hamburger-menu.open span:nth-child(4) {\n    top: 18px;\n    width: 0;\n    left: 50%;\n}\n\n/*\n# Main Menu\n--------------------------------*/\n.site-navigation ul {\n    margin: 0;\n    list-style: none;\n    position: fixed;\n    top: 0;\n    left: -320px;\n    z-index: 9999;\n    width: 320px;\n    max-width: calc(100% - 120px);\n    height: 100%;\n    overflow-x: scroll;\n    padding: 30px 15px;\n    background: rgba(0, 0, 0, .9);\n    transition: all 0.35s;\n}\n\n.site-navigation.show ul {\n    left: 0;\n}\n\n.site-navigation ul li a {\n    display: block;\n    padding: 12px 26px;\n    color: #fff;\n    text-decoration: none;\n    text-transform: uppercase;\n}\n\n@media screen and (min-width: 992px) {\n    .site-navigation ul {\n        position: relative;\n        top: auto;\n        left: auto;\n        width: 100%;\n        height: auto;\n        padding: 0;\n        overflow: auto;\n        background: transparent;\n    }\n}\n\n.site-navigation ul li a:hover,\n.site-navigation ul li.current-menu-item a {\n    color: #19c880;\n}\n\n/*\n# Menu SHopping Cart\n--------------------------------*/\n.header-bar-cart {\n    margin-left: 40px;\n}\n\n.header-bar-cart a {\n    width: 48px;\n    height: 100%;\n}\n\n.header-bar-cart a {\n    color: #fff;\n    text-decoration: none;\n}\n\n/*--------------------------------------------------------------\n# Hero Section\n--------------------------------------------------------------*/\n.hero-content {\n    /* background: url(\"images/hero-bg.jpg\") no-repeat center; */\n    background-size: cover;\n    height: 130px;\n}\n\n.hero-content-overlay {\n    background: rgba(21, 20, 33, .5);\n}\n\n.hero-content-wrap {\n    height: 820px;\n    padding-top: 130px;\n}\n\n.hero-content-wrap h4 {\n    font-size: 14px;\n    font-weight: 700;\n    text-transform: uppercase;\n    color: #19c880;\n    letter-spacing: 0.1em;\n}\n\n.hero-content-wrap h1 {\n    margin-top: 12px;\n    font-size: 60px;\n    font-weight: 500;\n    text-transform: uppercase;\n    color: #fff;\n}\n\n@media screen and (max-width: 576px) {\n    .hero-content-wrap h1 {\n        font-size: 32px;\n    }\n}\n\n.hero-content-wrap p {\n    margin-top: 8px;\n    color: #fff;\n}\n\n.hero-content-wrap .read-more {\n    margin-top: 40px;\n}\n\n.hero-content-wrap .read-more a {\n    display: block;\n    padding: 12px 40px;\n    border: 2px solid #19c880;\n    font-size: 13px;\n    font-weight: bold;\n    color: #fff;\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n    text-decoration: none;\n}\n\n.hero-content-wrap .read-more a:hover {\n    background: #19c880;\n}\n\n/*--------------------------------------------------------------\n# Homepage\n--------------------------------------------------------------*/\n/*\n# Icon Box\n--------------------------------*/\n.services-section {\n    border-bottom: 1px solid #ebebeb;\n}\n\n.icon-box {\n    width: 25%;\n    padding: 50px 60px 50px;\n    border-right: 1px solid #ebebeb;\n}\n\n@media screen and (max-width: 1440px) {\n    .icon-box {\n        padding: 40px;\n    }\n}\n\n@media screen and (max-width: 992px) {\n    .icon-box {\n        width: 50%;\n    }\n\n    .icon-box:nth-of-type(2) {\n        border-right: 0;\n    }\n\n    .icon-box:nth-of-type(1),\n    .icon-box:nth-of-type(2) {\n        border-bottom: 1px solid #ebebeb;\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .icon-box {\n        width: 100%;\n        border-right: 0;\n        border-bottom: 1px solid #ebebeb;\n    }\n}\n\n.icon-box:nth-last-of-type(1) {\n    border-right: 0;\n}\n\n.icon-box .icon {\n    font-size: 42px;\n    color: #19c880;\n}\n\n.icon-box .entry-title {\n    margin-top: 12px;\n    font-size: 22px;\n}\n\n.icon-box .entry-content p {\n    margin: 12px 0;\n    color: #757686;\n    line-height: 1.6;\n}\n\n.icon-box .read-more a {\n    position: relative;\n    padding-right: 10px;\n    font-size: 13px;\n    font-weight: 700;\n    color: #19c880;\n    text-decoration: none;\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n}\n\n.icon-box .read-more a .fa {\n    position: absolute;\n    top: 2px;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: #fff;\n    transition: all .35s;\n}\n\n.icon-box:hover .read-more a .fa {\n    left: 100%;\n}\n\n/*\n# Courses\n--------------------------------*/\n.courses-wrap .heading .entry-title {\n    margin: 0;\n    font-size: 42px;\n    font-weight: 400;\n}\n\n.courses-wrap .heading .courses-menu ul {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n}\n\n.courses-wrap .heading .courses-menu li {\n    padding-left: 40px;\n}\n\n.courses-wrap .heading .courses-menu li:nth-of-type(1) {\n    padding-left: 0;\n}\n\n.courses-wrap .heading .courses-menu li a {\n    border-bottom: 1px solid transparent;\n    font-size: 18px;\n    line-height: 1;\n    color: #383749;\n    text-decoration: none;\n}\n\n.courses-wrap .heading .courses-menu li a:hover,\n.courses-wrap .heading .courses-menu li.active a {\n    color: #19c880;\n    border-color: #19c880;\n}\n\n.mx-m-25 {\n    margin-right: -25px !important;\n    margin-left: -25px !important;\n}\n\n.px-25 {\n    padding-right: 25px !important;\n    padding-left: 25px !important;\n}\n\n.course-content {\n    margin-top: 50px;\n    transition: all .35s\n}\n\n.course-content:hover {\n    box-shadow: 0 24px 38px rgba(81, 107, 117, .21);\n}\n\n.course-thumbnail {\n    width: 100%;\n    margin: 0;\n    object-fit: cover;\n}\n\n.course-thumbnail img {\n    display: block;\n    width: 100%;\n    object-fit: cover;\n}\n\n.course-content-wrap {\n    padding: 26px 30px 20px;\n    border: 1px solid #ebebeb;\n    border-top: 0;\n    background: #fff;\n}\n\n.course-content .entry-title {\n    margin: 0;\n    font-size: 20px;\n    line-height: 1.3;\n    font-weight: 400;\n}\n\n.course-content .entry-title a {\n    color: #383749;\n}\n\n.course-content .entry-meta {\n    margin-top: 12px;\n}\n\n.course-author {\n    font-style: italic;\n}\n\n.course-author a {\n    color: #19c880;\n    text-decoration: none;\n}\n\n.course-date {\n    position: relative;\n    padding-left: 10px;\n    margin-left: 5px;\n    color: #757686;\n}\n\n.course-date::before {\n    content: '/';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 10px;\n    text-align: center;\n}\n\n.course-content .entry-footer {\n    margin-top: 14px;\n}\n\n.course-cost {\n    font-size: 24px;\n    font-weight: 700;\n    color: #19c880;\n}\n\n.course-cost .price-drop {\n    margin-left: 10px;\n    font-size: 20px;\n    font-weight: 400;\n    font-style: italic;\n    color: #c0c1cd;\n    text-decoration: line-through\n}\n\n.course-cost .free-cost {\n    font-size: 24px;\n    font-weight: 700;\n    color: #f3a90b;\n}\n\n.course-ratings {\n    font-size: 13px;\n    color: #c0c1cd;\n}\n\n.course-ratings span {\n    margin-left: 1px;\n}\n\n.course-ratings .checked {\n    color: #f3a90b;\n}\n\n.course-ratings .course-ratings-count {\n    margin-left: 5px;\n}\n\na.btn {\n    padding: 16px 48px;\n    border: 2px solid #34d986;\n    border-radius: 0;\n    font-size: 13px;\n    font-weight: bold;\n    line-height: 1;\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n    color: #383749;\n    text-decoration: none;\n    cursor: pointer;\n}\n\na.btn:hover {\n    color: #fff;\n    background: #34d986;\n}\n\n.btn {\n    cursor: pointer;\n}\n\n/*\n# Featured Courses: Horizontal Column\n--------------------------------*/\n.featured-courses.horizontal-column,\n.featured-courses.vertical-column {\n    padding: 100px 0;\n    background: #fff;\n}\n\n.featured-courses.horizontal-column .course-thumbnail {\n    width: calc(50% - 30px);\n    background: #fff;\n}\n\n.featured-courses.horizontal-column .course-thumbnail img {\n    height: 100%;\n}\n\n.featured-courses.horizontal-column .course-content-wrap {\n    width: calc(50% + 30px);\n    padding-left: 30px;\n    border: 1px solid #ebebeb;\n    border-left: 0;\n}\n\n.featured-courses.horizontal-column .course-ratings {\n    margin-bottom: 8px;\n}\n\n\n\n@media screen and (max-width: 576px) {\n    .featured-courses.horizontal-column .course-thumbnail {\n        width: 100%;\n    }\n\n    .featured-courses.horizontal-column .course-content-wrap {\n        width: 100%;\n        padding: 30px;\n        border: 1px solid #ebebeb;\n        border-top: 0;\n    }\n}\n\n/*\n# Featured Courses: Vertical Column\n--------------------------------*/\n.featured-courses.vertical-column {\n    background: #f7f7f7;\n}\n\n.featured-courses.vertical-column a.btn {\n    margin-top: 60px;\n}\n\n/*\n# About Section\n--------------------------------*/\n.about-section {\n    padding: 100px 0;\n    background: #f7f7f7;\n}\n\n.about-section .heading {\n    padding-right: 80px;\n}\n\n.about-section .heading .entry-title {\n    margin: 0;\n    font-size: 42px;\n    font-weight: 400;\n}\n\n.about-section .heading p {\n    margin-top: 15px;\n    font-size: 16px;\n    line-height: 1.8;\n    color: #757686;\n}\n\n.ezuca-stats {\n    padding-right: 80px;\n}\n\n.ezuca-stats .stats-count {\n    width: 50%;\n    margin-top: 16px;\n    font-size: 60px;\n    line-height: 1.2;\n    color: #19c880;\n}\n\n@media screen and (max-width: 576px) {\n    .ezuca-stats .stats-count {\n        width: 100%;\n    }\n}\n\n.ezuca-stats .stats-count span {\n    font-size: 36px;\n}\n\n.ezuca-stats .stats-count p {\n    font-size: 16px;\n    color: #757686;\n    text-transform: uppercase;\n}\n\n/*\n# About Section: Video\n--------------------------------*/\n.ezuca-video {\n    width: 100%;\n}\n\n.ezuca-video .video-play-btn {\n    top: 50%;\n    left: -40px;\n    z-index: 99;\n    width: 80px;\n    height: 80px;\n    margin-top: -40px;\n    cursor: pointer;\n}\n\n.ezuca-video img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n@media screen and (max-width: 992px) {\n    .about-section .heading {\n        padding-right: 0;\n    }\n\n    .ezuca-stats {\n        padding-right: 0;\n    }\n\n    .ezuca-video .video-play-btn {\n        left: 50%;\n        margin-left: -40px;\n    }\n}\n\n/*\n# About Section: Testimonial\n--------------------------------*/\n.testimonial-section {\n    padding: 100px 0;\n}\n\n.testimonial-slider .swiper-slide .user-avatar {\n    opacity: .3;\n    margin-bottom: 0;\n}\n\n.testimonial-slider .swiper-slide.swiper-slide-active .user-avatar {\n    opacity: 1;\n}\n\n.testimonial-slider .swiper-slide:nth-of-type(2) .user-avatar,\n.testimonial-slider .swiper-slide:nth-of-type(5) .user-avatar {\n    margin-left: calc(50% - 150px);\n}\n\n.testimonial-slider .swiper-slide:nth-of-type(3) .user-avatar {\n    margin-left: calc(50% - 40px);\n}\n\n.testimonial-slider .swiper-slide:nth-of-type(1) .user-avatar,\n.testimonial-slider .swiper-slide:nth-of-type(4) .user-avatar {\n    margin-left: calc(50% + 70px);\n}\n\n\n.testimonial-slider .swiper-slide-next {\n    opacity: 1 !important;\n}\n\n.testimonial-slider .user-avatar {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    overflow: hidden;\n}\n\n.testimonial-slider .user-avatar img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.testimonial-slider .content-wrap {\n    background: #fff;\n}\n\n.testimonial-slider .entry-content p {\n    font-size: 26px;\n    color: #383749;\n}\n\n.testimonial-slider .testimonial-user {\n    display: inline-block;\n    position: relative;\n    font-size: 16px;\n    font-weight: 300;\n    text-transform: uppercase;\n    color: #19c880;\n}\n\n.testimonial-slider .testimonial-user::after {\n    content: '';\n    position: absolute;\n    top: -12px;\n    right: -100px;\n    width: 38px;\n    height: 32px;\n    /* background: url(\"images/quote-icon.png\") no-repeat center; */\n}\n\n.testimonial-slider .testimonial-user span {\n    font-size: 14px;\n    color: #c0c1cd;\n    text-transform: initial;\n}\n\n.testimonial-slider .swiper-pagination-bullet {\n    width: 12px;\n    height: 12px;\n    margin: 0 6px;\n    border: 2px solid #c6adb8;\n    background: transparent;\n    opacity: 1;\n}\n\n.testimonial-slider .swiper-pagination-bullet.swiper-pagination-bullet-active {\n    background: #19c880;\n    border: transparent;\n}\n\n/*\n# Latest News & Events\n--------------------------------*/\n.latest-news-events {\n    padding: 100px 0;\n}\n\n.latest-news-events .heading .entry-title {\n    margin: 0 0 50px;\n    font-size: 42px;\n    font-weight: 400;\n}\n\n.latest-news-events .featured-event-content .event-thumbnail img {\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.latest-news-events .featured-event-content .posted-date {\n    bottom: 0;\n    left: 0;\n    padding: 10px 16px;\n    background: #f3a90b;\n    color: #fff;\n    line-height: 1;\n    text-align: center;\n}\n\n.latest-news-events .featured-event-content .posted-date .day {\n    font-size: 48px;\n    font-weight: bold;\n}\n\n.latest-news-events .featured-event-content .posted-date .month {\n    margin-top: 4px;\n    font-size: 18px;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n}\n\n.latest-news-events .featured-event-content {\n    padding-right: 20px;\n}\n\n.latest-news-events .featured-event-content .entry-title {\n    width: 100%;\n    margin-top: 32px;\n    font-size: 30px;\n    font-weight: 400;\n    color: #383749;\n}\n\n.latest-news-events .featured-event-content .event-location .fa,\n.latest-news-events .featured-event-content .event-duration .fa {\n    margin-right: 6px;\n    color: #34d986;\n}\n\n.latest-news-events .featured-event-content .event-location,\n.latest-news-events .featured-event-content .event-duration {\n    margin-top: 8px;\n    font-size: 14px;\n    text-transform: uppercase;\n    color: #c0c1cd;\n}\n\n.latest-news-events .featured-event-content .event-location {\n    margin-right: 24px;\n}\n\n.event-content {\n    margin-bottom: 30px;\n}\n\n.event-content .event-thumbnail {\n    width: 200px;\n    height: 200px;\n    margin: 0;\n}\n\n.event-content .event-thumbnail a {\n    display: block;\n}\n\n.event-content .event-content-wrap {\n    width: calc(100% - 230px);\n}\n\n.event-content .posted-date .fa {\n    margin-right: 6px;\n    color: #34d986;\n}\n\n.event-content .posted-date {\n    font-size: 14px;\n    text-transform: uppercase;\n    color: #c0c1cd;\n}\n\n.event-content .entry-title {\n    margin: 8px 0 0;\n    font-size: 20px;\n    line-height: 1.3;\n    font-weight: 400;\n}\n\n.event-content .entry-title a {\n    color: #383749;\n}\n\n.event-content .post-author {\n    margin-top: 14px;\n}\n\n.event-content .post-author a {\n    font-style: italic;\n    color: #19c880;\n    text-decoration: none;\n}\n\n.event-content .post-comments {\n    position: relative;\n    padding-left: 12px;\n    margin-top: 14px;\n    margin-left: 5px;\n    color: #757686;\n}\n\n.event-content .post-comments a {\n    text-decoration: none;\n    color: #757686;\n}\n\n.event-content .post-comments::before {\n    content: '/';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 10px;\n    text-align: center;\n}\n\n.event-content .entry-content {\n    margin-top: 14px;\n    margin-bottom: 0;\n    font-size: 16px;\n    color: #757686;\n}\n\n.event-content .entry-content p {\n    margin: 0;\n}\n\n@media screen and (max-width: 576px) {\n    .event-content .event-thumbnail {\n        width: 100%;\n        margin-bottom: 24px;\n    }\n\n    .event-content .event-content-wrap {\n        width: 100%;\n    }\n\n}\n\n/*\n# Gallery\n--------------------------------*/\n.home-gallery {\n    overflow: hidden;\n}\n\n.gallery-wrap {\n    margin-right: -5px;\n    margin-left: -5px;\n}\n\n.gallery-grid {\n    margin: 5px;\n    overflow: hidden;\n}\n\n.gallery-grid img {\n    display: block;\n    max-width: 100%\n}\n\n.gallery-grid1x1 {\n    width: calc(100% / 8 - 10px);\n}\n\n.gallery-grid2x1,\n.gallery-grid2x2 {\n    width: calc(100% / 4 - 10px);\n    margin-bottom: 6px;\n}\n\n.gallery-grid2x2 {\n    width: calc(100% / 4 - 10px);\n    margin-bottom: 7px;\n}\n\n@media screen and (max-width: 1200px) {\n    .gallery-grid1x1 {\n        width: calc(100% / 4 - 10px);\n    }\n\n    .gallery-grid2x1,\n    .gallery-grid2x2 {\n        width: calc(100% / 2 - 10px);\n    }\n\n    .gallery-grid2x2 {\n        width: calc(100% / 2 - 10px);\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .gallery-grid1x1 {\n        width: calc(100% / 2 - 10px);\n    }\n\n    .gallery-grid2x1,\n    .gallery-grid2x2 {\n        width: calc(100% / 1- 10px);\n        margin-bottom: 6px;\n    }\n\n    .gallery-grid2x2 {\n        width: calc(100% / 1 - 10px);\n        margin-bottom: 7px;\n    }\n}\n\n/*\n# Clients Logos\n--------------------------------*/\n.clients-logo {\n    margin-top: 100px;\n    padding: 16px 0;\n    background: #f7f7f7;\n}\n\n.logo-wrap {\n    margin: 16px;\n}\n\n/*--------------------------------------------------------------\n# Courses Page\n--------------------------------------------------------------*/\n.page-header {\n    background-size: cover !important;\n}\n\n.courses-page .page-header {\n    /* background: url(\"images/courses-header.jpg\") no-repeat center; */\n}\n\n.page-header-overlay {\n    background: rgba(21, 20, 33, .5);\n    height: 390px;\n    padding-top: 236px;\n}\n\n.page-header h1 {\n    font-size: 48px;\n    font-weight: 500;\n    color: #fff;\n    text-align: center;\n    padding-top: 100px;\n    text-transform: capitalize;\n}\n\n/*--------------------------------------------------------------\n# Breadcrumb\n--------------------------------------------------------------*/\n.breadcrumbs {\n    margin: 30px 0;\n}\n\n.breadcrumbs ul {\n    list-style: none;\n}\n\n.breadcrumbs li {\n    position: relative;\n    padding-right: 16px;\n    margin-right: 10px;\n    color: #c0c1cd;\n}\n\n.breadcrumbs li::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 6px;\n    height: 100%;\n    font-family: 'FontAwesome';\n}\n\n.breadcrumbs li:nth-last-of-type(1)::after {\n    display: none;\n}\n\n.breadcrumbs li a {\n    color: #383749;\n    text-decoration: none;\n}\n\n/*--------------------------------------------------------------\n# Pagination\n--------------------------------------------------------------*/\n.pagination {\n    margin-top: 50px;\n}\n\n.pagination ul {\n    list-style: none;\n}\n\n.pagination ul li {\n    margin-right: 10px;\n}\n\n.pagination ul li a {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 32px;\n    height: 38px;\n    border: 1px solid #ebebeb;\n    color: #757686;\n    text-decoration: none;\n}\n\n.pagination ul li a .fa {\n    color: #383749;\n}\n\n.pagination ul li:hover a,\n.pagination ul li.active a {\n    border-color: transparent;\n    background: #19c880;\n}\n\n.pagination ul li:hover a,\n.pagination ul li.active a,\n.pagination ul li:hover a .fa {\n    color: #fff;\n}\n\n.pagination-results {\n    color: #383749;\n}\n\n.pagination-results select {\n    padding: 6px 10px;\n    margin-left: 32px;\n    border: 1px solid #ebebeb;\n}\n\n/*--------------------------------------------------------------\n# Sidebar\n--------------------------------------------------------------*/\n.sidebar {\n    padding: 25px;\n    margin-top: 50px;\n    margin-left: 25px;\n    border: 1px solid #ebebeb;\n}\n\n@media screen and (max-width: 992px) {\n    .sidebar {\n        margin-left: 0;\n    }\n}\n\n/*\n# Search\n--------------------------------*/\n.search-widget input[type=\"search\"] {\n    width: calc(100% - 48px);\n    height: 48px;\n    padding: 10px 20px;\n    border: 1px solid #ebebeb;\n    font-size: 14px;\n    background: #f7f7f7;\n    color: #383749;\n    outline: none;\n}\n\n.search-widget input[type=\"search\"]::placeholder {\n    color: #c0c1cd;\n}\n\n.search-widget button[type=\"submit\"] {\n    width: 48px;\n    height: 48px;\n    border: 0;\n    background: #19c880;\n    color: #fff;\n    cursor: pointer;\n    outline: none;\n}\n\n/*\n# Categories\n--------------------------------*/\n.cat-links {\n    margin-top: 50px;\n}\n\n.cat-links h2 {\n    margin-bottom: 16px;\n    font-size: 24px;\n    font-weight: 400;\n}\n\n.cat-links ul {\n    list-style: none;\n}\n\n.cat-links ul li {\n    position: relative;\n    padding: 8px 0 8px 24px;\n}\n\n.cat-links ul li::before {\n    content: '';\n    position: absolute;\n    top: 8px;\n    left: 0;\n    width: 8px;\n    height: 100%;\n    font-size: 14px;\n    font-family: 'FontAwesome';\n    color: #c0c1cd;\n    ;\n}\n\n.cat-links ul li:hover::before {\n    color: #19c880;\n}\n\n.cat-links ul li a {\n    text-decoration: none;\n}\n\n/*\n# Latest Courses\n--------------------------------*/\n.latest-courses {\n    margin-top: 50px;\n}\n\n.latest-courses h2 {\n    margin-bottom: 16px;\n    font-size: 24px;\n    font-weight: 400;\n}\n\n.latest-courses li {\n    display: block;\n    margin-bottom: 20px;\n}\n\n.latest-courses li img {\n    width: 84px;\n}\n\n.latest-courses .content-wrap {\n    width: calc(100% - 108px);\n}\n\n.latest-courses .content-wrap h3 {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 1.6;\n}\n\n.latest-courses .content-wrap h3 a {\n    color: #383749;\n    text-decoration: none;\n}\n\n.latest-courses .content-wrap .course-cost {\n    margin-top: 10px;\n    font-size: 18px;\n    font-weight: 500;\n}\n\n.latest-courses .content-wrap .course-cost.free-cost {\n    color: #f3a90b;\n}\n\n/*\n# Ads\n--------------------------------*/\n.ads {\n    margin-top: 50px;\n}\n\n.ads img {\n    max-width: 100%;\n}\n\n/*\n# Latest Courses\n--------------------------------*/\n.popular-tags {\n    margin-top: 50px;\n}\n\n.popular-tags h2 {\n    margin-bottom: 16px;\n    font-size: 24px;\n    font-weight: 400;\n}\n\n.popular-tags ul {\n    list-style: none;\n}\n\n.popular-tags li a {\n    display: block;\n    padding: 8px 14px;\n    margin-right: 8px;\n    margin-bottom: 8px;\n    border: 1px solid #ebebeb;\n    font-size: 12px;\n    line-height: 1;\n    text-transform: uppercase;\n    color: #595959;\n    text-decoration: none;\n}\n\n.popular-tags li a:hover {\n    color: #383749;\n}\n\n/*--------------------------------------------------------------\n# Single Courses Page\n--------------------------------------------------------------*/\n.single-courses-page .page-header {\n    /* background: url(\"images/single-courses-bg.jpg\") no-repeat center; */\n}\n\n.single-courses-page .page-header-overlay {\n    height: 530px;\n}\n\n.single-courses-page .page-header-overlay h1 {\n    text-transform: uppercase;\n}\n\n.single-courses-page .featured-image {\n    position: relative;\n    margin-top: -80px;\n    box-shadow: 0 24px 38px rgba(81, 107, 117, .21);\n}\n\n.single-courses-page .featured-image img {\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.single-courses-page .featured-image .course-cost {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 120px;\n    padding: 10px;\n    font-size: 22px;\n    font-weight: bold;\n    color: #f3a90b;\n    background: #fff;\n    text-align: center;\n}\n\n@media screen and (max-width: 992px) {\n    .single-courses-page .featured-image {\n        margin-top: 80px;\n    }\n}\n\n/*\n# Course Info\n--------------------------------*/\n.course-info {\n    margin-top: 40px;\n}\n\n.course-info label {\n    color: #c0c1cd;\n}\n\n.course-info .course-author,\n.course-info .course-cats,\n.course-info .course-students {\n    padding-right: 20px;\n    margin-right: 20px;\n    border-right: 1px solid #ebebeb;\n}\n\n.course-author img {\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    margin-right: 20px;\n}\n\n.course-author a {\n    color: #19c880;\n}\n\n.course-students {\n    border: 0;\n}\n\n.single-course-cont-section {\n    margin-top: 24px;\n    color: #757686;\n}\n\n.single-course-cont-section h2 {\n    margin-top: 24px;\n    margin-bottom: 16px;\n    font-size: 24px;\n    font-weight: 400;\n    color: #383749;\n}\n\nul.green-ticked {\n    list-style: none;\n}\n\nul.green-ticked li {\n    position: relative;\n    padding-left: 24px;\n    margin-top: 8px;\n}\n\nul.green-ticked li::before {\n    content: '';\n    position: absolute;\n    top: 2px;\n    left: 0;\n    width: 20px;\n    height: 100%;\n    font-size: 14px;\n    font-family: 'FontAwesome';\n    color: #19c880;\n}\n\nul.black-doted {\n    list-style: none;\n}\n\n.single-course-cont-section ul.black-doted li {\n    position: relative;\n    padding-left: 24px;\n    margin-top: 8px;\n}\n\n.single-course-cont-section ul.black-doted li::before {\n    content: '';\n    position: absolute;\n    top: 3px;\n    left: 0;\n    width: 16px;\n    height: 100%;\n    font-size: 9px;\n    font-family: 'FontAwesome';\n}\n\n.single-course-accordion-cont h2 {\n    width: calc(100% - 280px);\n    /*min-width: 320px;*/\n    margin-top: 24px;\n    margin-bottom: 16px;\n    font-size: 24px;\n    font-weight: 400;\n    color: #383749;\n}\n\n.single-course-accordion-cont .number-of-lectures,\n.single-course-accordion-cont .lectures-preview,\n.single-course-accordion-cont .total-lectures-time {\n    font-size: 18px;\n    color: #19c880;\n}\n\n.single-course-accordion-cont .number-of-lectures,\n.single-course-accordion-cont .lectures-preview {\n    width: 140px;\n}\n\n.single-course-accordion-cont .total-lectures-time,\n.single-course-accordion-cont .lectures-time {\n    width: 120px;\n    text-align: right;\n}\n\n.single-course-accordion-cont .accordion-wrap .entry-title {\n    padding: 10px 16px 9px;\n    margin: 10px 0 0;\n    border: 1px solid #ebebeb;\n}\n\n.single-course-accordion-cont .accordion-wrap .entry-content {\n    padding: 10px 16px;\n    border: 1px solid #ebebeb;\n    border-top: 0;\n}\n\n.single-course-accordion-cont .arrow-d,\n.single-course-accordion-cont .arrow-r {\n    position: relative;\n    padding-right: 10px;\n    color: #19c880;\n}\n\n.single-course-accordion-cont .entry-title.active .fa-plus {\n    display: none;\n}\n\n.single-course-accordion-cont .entry-title .fa-minus {\n    display: none;\n}\n\n.single-course-accordion-cont .entry-title.active .fa-minus {\n    display: block;\n}\n\n.single-course-accordion-cont h3 {\n    font-size: 16px;\n    font-weight: 400;\n    color: #757686;\n}\n\n.single-course-accordion-cont .lecture-group-title {\n    width: calc(100% - 300px);\n}\n\n.single-course-accordion-cont ul {\n    list-style: none;\n    color: #757686;\n}\n\n.single-course-accordion-cont ul li {\n    margin-top: 8px;\n}\n\n.single-course-accordion-cont .lecture-title {\n    width: calc(100% - 280px);\n    color: #757686;\n}\n\n.single-course-accordion-cont .lectures-preview,\n.single-course-accordion-cont .lectures-time {\n    color: #757686;\n}\n\n.instructors-info {\n    margin-top: 50px;\n}\n\n.instructors-info .entry-heading h2 {\n    padding-bottom: 16px;\n    margin-bottom: 50px;\n    border-bottom: 1px solid #ebebeb;\n    font-size: 24px;\n    font-weight: 400;\n    color: #383749;\n}\n\n.instructors-stats {\n    width: 200px;\n    margin-right: 30px;\n}\n\n.instructors-stats img {\n    width: 120px;\n    height: 120px;\n    border-radius: 50%;\n    border: 1px solid #ebebeb;\n}\n\n.instructors-stats ul {\n    list-style: none;\n}\n\n.instructors-stats li {\n    margin-top: 10px;\n}\n\n.instructors-stats .fa {\n    margin-right: 2px;\n    font-size: 14px;\n    font-family: 'FontAwesome';\n    color: #19c880;\n}\n\n.instructors-details {\n    width: calc(100% - 230px);\n}\n\n.instructors-details .ratings {\n    color: #c0c1cd;\n}\n\n.instructors-details .ratings .fa-star-o {\n    color: #c0c1cd;\n}\n\n.instructors-details .ratings span {\n    margin-left: 4px;\n}\n\n.instructors-details h2 {\n    font-size: 30px;\n    font-weight: 400;\n    color: #383749;\n}\n\n.instructors-details .course-teacher {\n    color: #c0c1cd;\n}\n\n.instructors-details .course-teacher a {\n    color: #19c880;\n    font-weight: 600;\n    text-transform: uppercase;\n    text-decoration: navajowhite;\n}\n\n.instructors-details .entry-content {\n    color: #757686;\n    line-height: 1.8;\n}\n\n.related-courses {\n    margin-top: 50px;\n}\n\n.related-courses .entry-heading {\n    padding-bottom: 16px;\n    border-bottom: 1px solid #ebebeb;\n}\n\n.related-courses .entry-heading h2 {\n    font-size: 24px;\n    font-weight: 400;\n    color: #383749;\n}\n\n.related-courses .entry-heading a {\n    color: #19c880;\n    text-decoration: underline;\n}\n\n@media screen and (max-width: 992px) {\n    .single-course-accordion-cont .lecture-group-title {\n        width: calc(100% - 24px);\n        margin-bottom: 12px;\n    }\n\n    .single-course-accordion-cont h2,\n    .single-course-accordion-cont .lecture-title {\n        width: 100%;\n    }\n\n    .single-course-accordion-cont ul li {\n        margin-top: 24px;\n    }\n\n    .single-course-accordion-cont .total-lectures-time,\n    .single-course-accordion-cont .lectures-time,\n    .single-course-accordion-cont .number-of-lectures,\n    .single-course-accordion-cont .lectures-preview {\n        width: auto;\n        text-align: left;\n    }\n\n    .instructors-details {\n        margin-top: 50px;\n        width: 100%;\n    }\n}\n\n/*--------------------------------------------------------------\n# Ratings\n--------------------------------------------------------------*/\n.ratings {\n    font-size: 13px;\n    color: #fff;\n}\n\n.ratings .fa {\n    margin-right: 2px;\n}\n\n.ratings .fa-star {\n    margin-right: 2px;\n    color: #f3a90b;\n}\n\n.ratings .fa-star-o {\n    color: #fff;\n}\n\n/*--------------------------------------------------------------\n# Post Share\n--------------------------------------------------------------*/\n.post-share {\n    margin-top: 130px;\n}\n\n.post-share h3 {\n    margin-bottom: 20px;\n    font-size: 16px;\n    font-weight: 500;\n    text-transform: uppercase;\n    color: #757686;\n    text-align: center;\n}\n\n.post-share ul {\n    list-style: none;\n}\n\n.post-share ul li {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 8px;\n}\n\n.post-share .fa {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    color: #fff;\n}\n\n.post-share .fa-facebook {\n    background: #4b6cd0;\n}\n\n.post-share .fa-google-plus {\n    background: #f03b3b;\n}\n\n.post-share .fa-twitter {\n    background: #49a7f3;\n}\n\n.post-share .fa-instagram {\n    background: #bb8950;\n}\n\n.post-share .fa-thumb-tack {\n    background: #f0c605;\n}\n\n@media screen and (max-width: 992px) {\n    .post-share {\n        margin-top: 50px;\n    }\n\n    .post-share h3 {\n        text-align: left;\n    }\n\n    .post-share ul li {\n        margin: 0 5px;\n    }\n}\n\n/*--------------------------------------------------------------\n# About Page\n--------------------------------------------------------------*/\n.about-page .page-header {\n    /* background: url(images/courses-header.jpg) no-repeat center; */\n}\n\n.about-heading,\n.team-heading {\n    margin-top: 80px;\n    text-align: center;\n}\n\n.about-heading h2,\n.team-heading h2 {\n    font-size: 42px;\n    font-weight: 400;\n    color: #383749;\n}\n\n.about-heading p,\n.team-heading p {\n    margin-top: 20px;\n    color: #757686;\n}\n\n.about-stories,\n.about-values {\n    color: #757686;\n}\n\n.about-stories h3,\n.about-values h3 {\n    margin-top: 48px;\n    font-size: 24px;\n    font-weight: 400;\n    color: #383749;\n}\n\n.about-stories p,\n.about-values p {\n    line-height: 1.6;\n}\n\n.about-page .about-section {\n    margin-top: 100px;\n}\n\n.about-page .testimonial-section {\n    border-bottom: 1px solid #ebebeb;\n}\n\n.team-heading {\n    text-align: center;\n}\n\n.team-member {\n    padding: 32px 40px;\n    margin-top: 48px;\n    border: 1px solid #ebebeb;\n    text-align: center;\n    transition: all .35s;\n}\n\n.team-member:hover {\n    box-shadow: 0 0 38px rgba(81, 107, 117, .21);\n}\n\n.team-member img {\n    width: 180px;\n    max-width: 100%;\n    border-radius: 50%;\n}\n\n.team-member h3 {\n    margin-top: 24px;\n    font-size: 20px;\n    font-weight: 400;\n    color: #383749;\n}\n\n.team-member h4 {\n    font-size: 16px;\n    font-weight: 400;\n    color: #19c880;\n}\n\n.team-member ul {\n    margin-top: 24px !important;\n    list-style: none;\n}\n\n.team-member ul li {\n    margin: 0 10px;\n}\n\n.team-member ul li a {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 48px;\n    height: 48px;\n    border: 1px solid #ebebeb;\n    border-radius: 50%;\n    text-decoration: none;\n    transition: all .35s;\n}\n\n.team-member ul li .fa {\n    font-size: 18px;\n    font-family: 'FontAwesome';\n    color: #c0c1cd;\n}\n\n.team-member ul li a:hover {\n    border-color: transparent;\n    background: #19c880;\n}\n\n.team-member ul li a:hover .fa {\n    color: #fff;\n}\n\n/*--------------------------------------------------------------\n# Blog Page\n--------------------------------------------------------------*/\n.blog-page .page-header {\n    /* background: url(\"images/courses-header.jpg\") no-repeat center; */\n}\n\n.blog-posts {\n    margin-top: 50px;\n}\n\n.blog-post-content {\n    margin-bottom: 30px;\n}\n\n.blog-post-content .blog-post-thumbnail img {\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.blog-post-content .posted-date {\n    bottom: 0;\n    left: 0;\n    padding: 8px 16px;\n    background: #f3a90b;\n    color: #fff;\n    line-height: 1;\n    text-align: center;\n}\n\n.blog-post-content .posted-date .day {\n    font-size: 36px;\n    font-weight: bold;\n}\n\n.blog-post-content .posted-date .month {\n    margin-top: 4px;\n    font-size: 16px;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n}\n\n.blog-post-content-wrap .entry-title {\n    margin: 24px 0 0;\n    font-size: 24px;\n    line-height: 1.4;\n    font-weight: 400;\n}\n\n.blog-post-content-wrap .post-author {\n    margin-top: 12px;\n}\n\n.blog-post-content-wrap .post-author a {\n    font-style: italic;\n    color: #19c880;\n    text-decoration: none;\n}\n\n.blog-post-content-wrap .post-comments {\n    position: relative;\n    padding-left: 12px;\n    margin-top: 12px;\n    margin-left: 5px;\n}\n\n.blog-post-content-wrap .post-comments a {\n    text-decoration: none;\n    color: #757686;\n}\n\n.blog-post-content-wrap .post-comments::before {\n    content: '/';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 10px;\n    text-align: center;\n}\n\n.blog-post-content-wrap .entry-content {\n    margin-top: 12px;\n    margin-bottom: 0;\n    color: #757686;\n}\n\n/*--------------------------------------------------------------\n# Single Blog Post\n--------------------------------------------------------------*/\n.single-blog-post .page-header {\n    /* background: url(\"images/single-courses-bg.jpg\") no-repeat center; */\n}\n\n.single-blog-post .page-header-overlay {\n    height: 530px;\n}\n\n.single-blog-post .page-header .post-author a {\n    font-style: italic;\n    color: #19c880;\n    text-decoration: none;\n}\n\n.single-blog-post .page-header .post-comments {\n    position: relative;\n    padding-left: 12px;\n    margin-left: 5px;\n}\n\n.single-blog-post .page-header .post-comments::before {\n    content: '/';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 10px;\n    text-align: center;\n    color: #fff;\n}\n\n.single-blog-post .page-header .post-comments a {\n    text-decoration: none;\n    color: #fff;\n}\n\n.single-blog-post .featured-image {\n    position: relative;\n    margin-top: -80px;\n    box-shadow: 0 24px 38px rgba(81, 107, 117, .21);\n}\n\n.single-blog-post .featured-image img {\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.single-blog-post .featured-image .posted-date {\n    bottom: 0;\n    left: 0;\n    padding: 10px 16px;\n    background: #f3a90b;\n    color: #fff;\n    line-height: 1;\n    text-align: center;\n}\n\n.single-blog-post .featured-image .posted-date .day {\n    font-size: 48px;\n    font-weight: bold;\n}\n\n.single-blog-post .featured-image .posted-date .month {\n    margin-top: 4px;\n    font-size: 18px;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n}\n\n.single-post-wrap {\n    padding-bottom: 24px;\n    margin-top: 50px;\n    border-bottom: 1px solid #ebebeb;\n    color: #757686;\n}\n\n.single-post-wrap blockquote {\n    position: relative;\n    padding-left: 68px;\n    margin-top: 24px;\n    margin-bottom: 32px;\n    font-size: 20px;\n    font-weight: 300;\n    color: #383749;\n}\n\n.single-post-wrap blockquote::before {\n    content: '';\n    position: absolute;\n    top: 10px;\n    left: 0;\n    width: 26px;\n    height: 20px;\n    /* background: url(\"images/quote.png\") no-repeat; */\n}\n\n.single-post-wrap blockquote span {\n    display: block;\n    margin-top: 10px;\n    font-size: 16px;\n    font-weight: 500;\n    color: #19c880;\n}\n\n.single-post-wrap img {\n    max-width: 100%;\n}\n\n.single-post-wrap h3 {\n    font-size: 24px;\n    font-weight: 400;\n    color: #383749;\n}\n\n.tags-links ul {\n    list-style: none;\n}\n\n.tags-links li {\n    margin-right: 10px;\n}\n\n.tags-links li a {\n    display: block;\n    padding: 10px 24px;\n    font-size: 12px;\n    line-height: 1;\n    color: #595959;\n    text-transform: uppercase;\n    background: #f3f3f3;\n}\n\n@media screen and (max-width: 992px) {\n    .single-blog-post .featured-image {\n        margin-top: 80px;\n    }\n}\n\n.related-blog-posts {\n    margin-top: 50px;\n}\n\n.related-blog-posts .entry-heading {\n    padding-bottom: 16px;\n    border-bottom: 1px solid #ebebeb;\n}\n\n.related-blog-posts .entry-heading h2 {\n    font-size: 24px;\n    font-weight: 400;\n    color: #383749;\n}\n\n.related-blog-posts .entry-heading a {\n    color: #19c880;\n    text-decoration: underline;\n}\n\n.related-blog-posts .blog-post-content {\n    margin-top: 50px;\n}\n\n.author-box {\n    padding-top: 60px;\n    margin-top: 60px;\n    border-top: 1px solid #ebebeb;\n}\n\n.author-avatar {\n    width: 160px;\n    margin-right: 30px;\n}\n\n.author-avatar img {\n    width: 120px;\n    height: 120px;\n    border-radius: 50%;\n    border: 1px solid #ebebeb;\n}\n\nul.author-social-profile {\n    list-style: none;\n}\n\nul.author-social-profile li {\n    margin: 0 10px;\n}\n\nul.author-social-profile .fa {\n    font-size: 18px;\n    font-family: 'FontAwesome';\n    color: #c0c1cd;\n}\n\nul.author-social-profile li:hover .fa {\n    color: #19c880;\n}\n\n.author-details {\n    width: calc(100% - 190px);\n}\n\n@media screen and (max-width: 576px) {\n    .author-details {\n        width: 100%;\n        margin-top: 32px;\n    }\n}\n\n.author-details h3 {\n    font-size: 16px;\n    font-weight: 400;\n    text-transform: uppercase;\n    color: #19c880;\n}\n\n.author-details h3 span {\n    display: block;\n    margin-top: 6px;\n    text-transform: capitalize;\n    color: #c0c1cd;\n}\n\n.author-details p {\n    color: #757686;\n    line-height: 1.8;\n}\n\n/*\n# Comments\n--------------------------------*/\n.post-comments-wrap .post-comments {\n    margin-top: 40px;\n    padding-top: 50px;\n    padding-bottom: 50px;\n    border-top: 1px solid #ebebeb;\n    border-bottom: 1px solid #ebebeb;\n}\n\n.comments-title,\n.comment-reply-title {\n    margin-bottom: 0;\n    font-size: 24px;\n    font-weight: 400;\n    color: #383749;\n}\n\n.post-comments-wrap .comment-list {\n    padding: 0;\n    margin: 0;\n    list-style: none\n}\n\n.post-comments-wrap .comment-author-avatar {\n    float: left;\n    width: 70px;\n    height: 70px;\n    margin-top: 36px;\n    margin-right: 22px;\n    margin-bottom: 0;\n    border-radius: 50%;\n    overflow: hidden;\n}\n\n.post-comments-wrap .comment-author-avatar img {\n    width: 100%;\n    height: auto;\n}\n\n.post-comments-wrap .comment-wrap {\n    float: right;\n    width: calc(100% - 92px);\n    margin-top: 32px;\n}\n\n.post-comments-wrap .comment-author .fn {\n    display: block;\n    margin-top: 4px;\n}\n\n.post-comments-wrap .comment-author .fn a {\n    font-size: 18px;\n    color: #383749;\n}\n\n.post-comments-wrap .comment-author .comment-meta a {\n    font-size: 12px;\n    text-transform: uppercase;\n    letter-spacing: 0.12em;\n    color: #19c880;\n}\n\n.post-comments-wrap p {\n    margin-top: 5px;\n    color: #757686;\n}\n\n.post-comments-wrap .reply {\n    margin-top: 8px;\n}\n\n.post-comments-wrap .reply a {\n    display: inline-block;\n    padding: 8px 18px;\n    margin-right: 10px;\n    border: 1px solid #d2d2d4;\n    border-radius: 2px;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 1;\n    color: #383749;\n    text-transform: uppercase;\n    text-decoration: none;\n    letter-spacing: 1px;\n}\n\n.post-comments-wrap .reply a:hover {\n    border-color: transparent;\n    color: #fff;\n    background: #19c880;\n}\n\n.post-comments-wrap ol.children {\n    padding: 0;\n    margin-left: 92px;\n    list-style: none;\n}\n\n.post-comments-wrap ol.children .comment-author-avatar {\n    margin-top: 40px;\n    margin-right: 22px;\n}\n\n.post-comments-wrap ol.children .comment-wrap {\n    margin-top: 36px;\n    width: calc(100% - 92px);\n}\n\n/*\n# Comment Form\n--------------------------------*/\n.comments-form {\n    margin-top: 50px;\n}\n\n.comment-reply-title {\n    margin-bottom: 16px;\n}\n\n.comment-form input[type=\"text\"],\n.comment-form input[type=\"email\"],\n.comment-form input[type=\"url\"],\n.comment-form textarea {\n    width: 100%;\n    padding: 14px 24px;\n    margin-top: 20px;\n    border: 1px solid #e5e5e5;\n    line-height: 1;\n    color: #383749;\n    outline: none;\n}\n\n.comment-form input[type=\"text\"]::placeholder,\n.comment-form input[type=\"email\"]::placeholder,\n.comment-form input[type=\"url\"]::placeholder,\n.comment-form textarea::placeholder {\n    color: #c0c1cd;\n}\n\n.comment-form textarea {\n    line-height: 1.4;\n}\n\n.comment-form input[type=\"text\"]:focus,\n.comment-form input[type=\"email\"]:focus,\n.comment-form input[type=\"url\"]:focus,\n.comment-form textarea:focus {\n    border-color: #19c880;\n}\n\n.comment-form input[type=\"submit\"] {\n    padding: 16px 32px;\n    margin-top: 40px;\n    margin-bottom: 10px;\n    border: 0;\n    border-radius: 2px;\n    font-size: 13px;\n    font-weight: 600;\n    line-height: 1;\n    color: #fff;\n    text-transform: uppercase;\n    text-decoration: none;\n    letter-spacing: 0.1rem;\n    outline: none;\n    cursor: pointer;\n    background: #19c880;\n}\n\n/*--------------------------------------------------------------\n# Contact Page\n--------------------------------------------------------------*/\n.contact-page .page-header {\n    /* background: url(images/courses-header.jpg) no-repeat center; */\n}\n\n.contact-page .contact-gmap {\n    margin-top: 60px;\n    box-shadow: 0 24px 38px rgba(81, 107, 117, .21);\n}\n\n.contact-page .contact-gmap iframe {\n    display: block;\n    width: 100%;\n    height: 540px;\n}\n\n.contact-form,\n.contact-info {\n    margin-top: 80px;\n}\n\n.contact-form h3,\n.contact-info h3 {\n    margin-bottom: 12px;\n    font-size: 36px;\n    font-weight: 400;\n    color: #383749;\n}\n\n.contact-form input[type=\"text\"],\n.contact-form input[type=\"email\"],\n.contact-form textarea {\n    width: 100%;\n    padding: 12px 20px;\n    margin-top: 18px;\n    border: 1px solid #ebebeb;\n    background: #f7f7f7;\n    color: #383749;\n}\n\n.contact-form input[type=\"text\"]:focus,\n.contact-form input[type=\"email\"]:focus,\n.contact-form textarea:focus {\n    outline: none;\n}\n\n.contact-form input[type=\"text\"]::placeholder,\n.contact-form input[type=\"email\"]::placeholder,\n.contact-form textarea::placeholder {\n    color: #c0c1cd;\n}\n\n.contact-form input[type=\"submit\"] {\n    padding: 16px 32px;\n    margin-top: 40px;\n    margin-bottom: 10px;\n    border: 0;\n    border-radius: 2px;\n    font-size: 13px;\n    font-weight: 600;\n    line-height: 1;\n    color: #fff;\n    text-transform: uppercase;\n    text-decoration: none;\n    letter-spacing: 0.1rem;\n    outline: none;\n    cursor: pointer;\n    background: #19c880;\n}\n\n.contact-info p {\n    margin-top: 24px;\n    line-height: 1.8;\n    color: #757686;\n}\n\n.contact-info ul {\n    list-style: none;\n}\n\n.contact-info li {\n    margin-top: 32px;\n    font-size: 24px;\n    color: #383749;\n}\n\n.contact-info li span {\n    display: block;\n    font-size: 18px;\n    color: #c0c1cd;\n}\n\n.contact-info li a {\n    color: #636363;\n    text-decoration: navajowhite;\n}\n\n@media screen and (min-width: 992px) {\n    .contact-form {\n        padding-right: 40px;\n    }\n\n    .contact-info {\n        padding-left: 40px;\n    }\n}\n\n/*--------------------------------------------------------------\n# Footer\n--------------------------------------------------------------*/\n.footer-widgets {\n    padding: 35px 0;\n    color: #fff;\n    background-color: #c62829;\n}\n\n.foot-about p {\n    margin-top: 40px;\n    font-size: 16px;\n    line-height: 1.6;\n    color: #757686;\n}\n\np.footer-copyright {\n    color: #c0c1cd;\n}\n\n.footer-widgets h2 {\n    margin-bottom: 40px;\n    font-size: 33px;\n    color: #fff;\n    border-bottom: 0.0675rem solid #fff;\n    padding-bottom: 1.5rem;\n}\n\n.footer-widgets ul {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n}\n\n.footer-widgets ul li {\n    margin-bottom: 0.5rem;\n    text-transform: uppercase;\n    font-size: 13px;\n}\n\n.footer-widgets ul li a {\n    color: #fff;\n    text-decoration: none;\n    font-size: 13px;\n}\n\n.footer-widgets ul li a:hover {\n    color: #000;\n}\n\n.footer-widgets .follow-us .fa {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    margin-right: 10px;\n    color: #fff;\n}\n\n.footer-widgets .follow-us .fa-facebook {\n    background: #4b6cd0;\n}\n\n.footer-widgets .follow-us .fa-google-plus {\n    background: #f03b3b;\n}\n\n.footer-widgets .follow-us .fa-instagram {\n    background: #bb8950;\n}\n\n.footer-widgets .follow-us .fa-twitter {\n    background: #49a7f3;\n}\n\n.footer-bar {\n    padding: 30px 0;\n    border-top: 1px solid #ebebeb;\n}\n\n.footer-bar .download-apps a {\n    display: block;\n    margin-right: 10px;\n}\n\n.footer-bar .download-apps a img {\n    display: block;\n}\n\n.footer-bar-nav ul {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n}\n\n.footer-bar-nav ul li {\n    margin-left: 30px;\n}\n\n@media screen and (max-width: 992px) {\n    .footer-bar-nav ul li {\n        margin-left: 15px;\n        margin-right: 15px;\n    }\n}\n\n.footer-bar-nav ul li a {\n    color: #757686;\n    text-decoration: none;\n}\n\n.footer-bar-nav ul li a:hover {\n    color: #34d986;\n}\n\n.img-fluid {\n    height: auto;\n    max-width: 60%;\n}\n\n.inner-header .img-fluid {\n    height: auto;\n    max-width: 65%;\n}\n\n.inner-header .login_image {\n    height: auto;\n    max-width: 92%;\n}\n\n\n.btn-outline-primary {\n    border-color: #c62829 !important;\n    border: 1px solid #c62829 !important;\n    color: #000;\n    border-radius: 0;\n}\n\n.btn-primary {\n    background-color: #c62829 !important;\n    border-color: #c62829 !important;\n    border: 1px solid #c62829 !important;\n    border-radius: 0;\n}\n\n.btn-icon-text {\n    width: 156px;\n    height: 32px;\n    font-size: 13px;\n}\n\n.btn-primary:hover {\n    color: #fff;\n    background-color: #c62829 !important;\n    border-color: #c62829 !important;\n    border: 1px solid #c62829 !important;\n}\n\n.btn-outline-primary:hover {\n    color: #fff;\n    background-color: #c62829 !important;\n    border-color: #c62829 !important;\n    border: 1px solid #c62829 !important;\n}\n\n.btn-default {\n    height: 32px;\n    background-color: transparent;\n}\n\n.main-img {\n    position: relative;\n    width: 100%;\n    max-width: 672px;\n}\n\n.main-img img {\n    width: 100%;\n    height: auto;\n}\n\n.main-img .btn-menu {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    background-color: #EF7F1A;\n    color: white;\n    font-size: 18px;\n    border: none;\n    cursor: pointer;\n    border-radius: 0px;\n    text-align: center;\n    width: 198px;\n    height: 40px;\n}\n\n.main-img .btn-menu:hover {\n    background-color: black;\n}\n\n.main-img .btn-products {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    background-color: #c62829;\n    color: white;\n    font-size: 18px;\n    border: none;\n    cursor: pointer;\n    border-radius: 0px;\n    text-align: center;\n    width: 198px;\n    height: 40px;\n}\n\n.main-img .btn-products:hover {\n    background-color: black;\n}\n\n.container-fluid {\n    padding-right: 0;\n    padding-left: 0;\n}\n\n.main-img-text {\n    font-size: 18px;\n    color: #363636;\n    text-align: center;\n}\n\n.price {\n    font-size: 25px;\n    color: #c62829;\n}\n\n\n.service-btn {\n    background-color: #9D9E9E;\n    color: #fff;\n    width: 163px;\n    height: 40px;\n    font-size: 15px;\n}\n\nfooter .contact-icons {\n    font-size: 22px;\n    text-transform: uppercase;\n}\n\n.list-group {\n    flex-direction: row;\n}\n\n.list-group-horizontal .list-group-item {\n    display: inline-block;\n}\n\n.list-group-horizontal .list-group-item {\n    margin-bottom: 0;\n    margin-left: -4px;\n    margin-right: 0;\n    border-right-width: 0;\n}\n\n.list-group-horizontal .list-group-item:first-child {\n    border-top-right-radius: 0;\n    border-bottom-left-radius: 0px;\n}\n\n.list-group-horizontal .list-group-item:last-child {\n    border-top-right-radius: 0px;\n    border-bottom-left-radius: 0;\n    border-right-width: 1px;\n}\n\n.list-group-item {\n    position: relative;\n    display: block;\n    padding: 0.5rem 1.25rem;\n    margin-bottom: -1px;\n    border: 1px solid #fff !important;\n    background-color: transparent !important;\n}\n\n.list-group-item:first-child {\n    border-top-left-radius: 0 !important;\n    border-top-right-radius: 0 !important;\n}\n\n.list-group-item:last-child {\n    margin-bottom: 0;\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.e-menu-img {\n    /* background-image: url(\"./images/e-menu.png\"); */\n    background-color: #cccccc;\n    background-size: cover;\n    background-repeat: no-repeat;\n    display: block;\n    height: 650px;\n}\n\n.e-menu-img .btn-menu {\n    position: absolute;\n    top: 22%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    background-color: #EF7F1A;\n    color: white;\n    font-size: 18px;\n    border: none;\n    cursor: pointer;\n    border-radius: 0px;\n    text-align: center;\n    width: 198px;\n    height: 40px;\n}\n\n.e-menu-img .btn-menu:hover {\n    background-color: black;\n}\n\n.e-products-img {\n    /* background-image: url(\"./images/my-products.png\"); */\n    background-color: #cccccc;\n    background-size: cover;\n    background-repeat: no-repeat;\n    display: block;\n    height: 650px;\n}\n\n@media screen and (max-width: 992px) {\n    .e-products-img {\n        height: 600px;\n    }\n\n    .e-menu-img {\n        height: 600px;\n    }\n\n    .e-menu-img .btn-menu {\n        top: 22% !important;\n    }\n\n    .e-products-img .btn-products {\n        top: 22% !important;\n    }\n}\n\n.e-products-img .btn-products {\n    position: absolute;\n    top: 22%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    background-color: #c62829;\n    color: white;\n    font-size: 18px;\n    border: none;\n    cursor: pointer;\n    border-radius: 0px;\n    text-align: center;\n    width: 198px;\n    height: 40px;\n}\n\n.e-products-img .btn-products:hover {\n    background-color: black;\n}\n\n.header-image {\n    height: 260px;\n    width: 100%;\n}\n\n.cont-bg {\n    background-color: #f5f5f5;\n    padding-top: 3rem;\n    padding-bottom: 3rem\n}\n\n.register-page .page-header {\n    background: url(\"../images/header.png\") no-repeat center;\n    height: 260px;\n}\n\n.register-page .login_image {\n    background: url(\"../images/BANER_login.jpg\") no-repeat center;\n    height: 260px;\n}\n\n.register-page .register_image {\n    background: url(\"../images/BANER_register.jpg\") no-repeat center;\n    height: 260px;\n}\n\n.register-page .card {\n    border-radius: 0;\n    border: 0;\n}\n\n.register-page .card .form-heading {\n    background-color: #c62829;\n    border-radius: 4px;\n    color: #fff;\n    margin-bottom: 34px;\n    padding: 6px 15px;\n    font-size: 16px;\n}\n\n\n\n.register-page .card .accord-heading {\n    background-color: #c62829;\n    border-radius: 4px;\n    color: #fff;\n}\n\n.register-page .card .form-heading {\n    font-size: 16px;\n}\n\n.register-page .card-body {\n    padding: 20px 20px 20px 20px;\n}\n\n.regpage .auth-content form .form-group {\n    margin-bottom: 15px;\n}\n\n.form-control {\n    display: block;\n    width: 100%;\n    padding: 0.375rem 0.75rem;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #212529;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid #ced4da;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    border-radius: 0.375rem;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\nselect {\n    word-wrap: normal;\n}\n\n.form-select {\n    display: block;\n    width: 100%;\n    padding: 0.375rem 0.75rem;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #212529;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid #ced4da;\n    /* -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: auto; */\n    border-radius: 0.375rem;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.btn-danger {\n    background-color: #c62829;\n    font-weight: bold;\n    /* font-size: 20px; */\n}\n\n.plan .columns {\n    width: 50%;\n    padding: 8px;\n}\n\n.plan .price {\n    list-style-type: none;\n    border: 1px solid #c62829;\n    margin: 0;\n    padding: 0;\n    -webkit-transition: 0.3s;\n    transition: 0.3s;\n}\n\n.plan .price:hover {\n    box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.2)\n}\n\n.plan .price .header {\n    background-color: #111;\n    color: white;\n    font-size: 16px;\n}\n\n.plan .price li {\n    border-bottom: 1px solid #eee;\n    padding: 10px;\n    text-align: center;\n}\n\n.plan .price .grey {\n    background-color: #eee;\n    font-size: 25px;\n    color: #c62829;\n}\n\n.plan .button {\n    background-color: #EF7F1A;\n    border: none;\n    color: white;\n    padding: 6px 25px;\n    text-align: center;\n    text-decoration: none;\n    font-size: 18px;\n    font-weight: 400;\n    border-radius: 0.25rem;\n}\n\n.plan .price {\n    font-size: 16px;\n    color: #383749;\n}\n\n.columns {\n    width: 65%;\n}\n\n@media only screen and (max-width: 600px) {\n    .columns {\n        width: 80%;\n    }\n}\n\n.country-list {\n    margin-bottom: 1rem;\n    border: unset;\n    width: 157px;\n    appearance: none !important;\n    -webkit-appearance: none !important;\n    border-left: 1px solid #ccc;\n    border-radius: 0;\n    float: right;\n}\n\n.site-navigation .form-select {\n    background-image: unset !important;\n}\n\n.modal {\n    display: none;\n    /* Hidden by default */\n    position: fixed;\n    /* Stay in place */\n    z-index: 1;\n    /* Sit on top */\n    padding-top: 100px;\n    /* Location of the box */\n    left: 0;\n    top: 0;\n    width: 100%;\n    /* Full width */\n    height: 100%;\n    /* Full height */\n    overflow: auto;\n    /* Enable scroll if needed */\n    background-color: rgb(0, 0, 0);\n    /* Fallback color */\n    background-color: rgba(0, 0, 0, 0.4);\n    /* Black w/ opacity */\n}\n\n/* Modal Content */\n.modal-content {\n    background-color: #fefefe;\n    margin: auto;\n    padding: 20px;\n    border: 1px solid #888;\n    width: 80%;\n}\n\n/* The Close Button */\n.close {\n    color: #aaaaaa;\n    float: right;\n    font-size: 28px;\n    font-weight: bold;\n}\n\n.close:hover,\n.close:focus {\n    color: #000;\n    text-decoration: none;\n    cursor: pointer;\n}\n\n.save {\n    padding: 6px 25px;\n}\n\n.cuisine .card {\n    align-items: center;\n    border: 1px solid #bfc1c1;\n    border-radius: 3px;\n    box-shadow: 4px 4px 4px rgba(0, 0, 0, .2);\n    height: 120px;\n    margin-bottom: 2rem;\n    margin-top: 2rem;\n    width: 120px;\n}\n\n\n.cuisine .card:hover {\n    border: 2px solid #c62829;\n    cursor: pointer;\n}\n\n.cuisine .card .card-img {\n    height: 40px;\n    width: auto;\n    margin-top: 15px;\n}\n\n.cuisine .card-text {\n    font-size: 13px;\n    color: #252525;\n    text-align: center;\n}\n\n.cuisine .card-body {\n    padding: 15px 10px 10px 10px;\n    line-height: 1.5;\n}\n\n.cuisine {\n    margin-bottom: 2rem;\n}\n\n.cuisine .col {\n    flex-grow: 0;\n    padding-left: 20px;\n    padding-right: 20px;\n}\n\n.img-responsive {\n    display: block;\n    max-width: 100%;\n    height: auto;\n}\n\n\n\n.menu-card .card .container {\n    border: 2px solid #889F2C;\n    margin-top: -12px;\n    padding: 25px;\n}\n\n.menu-card .card .templete3 .container {\n    border: 0;\n}\n\n.menu-card .card .container h6 {\n    text-transform: uppercase;\n    color: #545454;\n}\n\n.menu-card p {\n    line-height: 1.4;\n    font-size: 12px;\n    color: #878787;\n}\n\n@media only screen and (max-width: 767px) {\n    .menu-card .card {\n        width: auto;\n    }\n}\n\n.menu-card .img {\n    padding: 0 0 1rem 0;\n}\n\n.design .card {\n    border: 1px solid #BFC1C1;\n    border-radius: 3px;\n    margin-bottom: 2rem;\n    display: block;\n    padding: 2rem 1rem;\n    height: 512px;\n}\n\n.design .card img {\n    border: 1px solid #BFC1C1;\n    border-radius: 3px;\n    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%);\n}\n\n.design .card-body {\n    text-align: left;\n    padding: inherit !important;\n}\n\n.design ul li {\n    color: red;\n}\n\n.design ul {\n    height: 135px;\n}\n\n.text-black {\n    color: #383749;\n}\n\n.design .form-check .form-check-input {\n    height: 30px;\n    width: 30px;\n    margin-left: 1.3rem;\n}\n\n.qrcode .card {\n    border: 1px solid #BFC1C1;\n    height: 290px;\n    text-align: center;\n    display: block !important;\n    box-shadow: unset !important;\n    padding: 0 !important;\n    width: auto !important;\n}\n\n.qrcode .card img {\n    width: 133px;\n    text-align: center;\n}\n\n.qrcode h3 {\n    padding: 1rem 0;\n    font-size: 25px;\n}\n\n.payment-btn {\n    font-size: 20px;\n    font-weight: bold;\n    text-align: center;\n    display: block;\n}\n\n.btn-secondary {\n    background-color: #EF7F1A;\n    padding: 6px 25px;\n    border-color: transparent;\n}\n\n.fa-caret-up {\n    font-size: 1.7rem;\n}\n\n.fa-caret-down {\n    font-size: 1.7rem;\n    margin-left: 5px;\n}\n\n.fa-pencil-square {\n    font-size: 1.3rem;\n    margin-left: 8px;\n    color: #9D9F9E;\n}\n\n.fa-times-circle {\n    font-size: 1.3rem;\n    margin-left: 8px;\n    color: #C62829;\n}\n\n.seemore {\n    position: absolute;\n    top: 24.7%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    color: white;\n    font-size: 16px;\n    border: none;\n    cursor: pointer;\n    text-align: center;\n}\n\n.login .card {\n    width: 60%;\n}\n\n/* #updateServices .login .card {\n    width: 30%;\n} */\n\n\n@media only screen and (max-width: 767px) {\n    .login .card {\n        width: auto;\n    }\n}\n\n.postlogin .page-header {\n    background-image: url(\"../images/header.png\") no-repeat center !important;\n    height: 260px;\n}\n\n.service .columns {\n    width: 80%;\n}\n\n@media only screen and (max-width: 600px) {\n    .service .columns {\n        width: 90%;\n    }\n}\n\n@media only screen and (max-width: 991px) {\n    .img-fluid {\n        height: auto;\n        max-width: 90%;\n    }\n}\n\n\n\n@media only screen and (max-width: 793px) {\n    .img-fluid {\n        height: auto;\n        max-width: 70%;\n    }\n}\n\n@media only screen and (max-width: 574px) {\n    .img-fluid {\n        height: auto;\n        max-width: 50%;\n    }\n}\n\n.edit-profile-img img {\n    width: auto;\n    height: 60px;\n}\n\n@media (min-width: 576px) {\n    .dashboard .card-columns {\n        display: flex;\n    }\n}\n\n.dashboard .card-columns .card {\n    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%);\n    align-items: center;\n    border: 0;\n    border-radius: 8px;\n    margin-top: 1rem;\n    margin-bottom: 5rem;\n    background-color: #fff;\n}\n\n.dashboard .card-columns .card .card-text {\n    font-weight: 500;\n    font-size: 18px;\n    margin-bottom: 0.5rem;\n}\n\n.dashboard .card-columns .card .card-title {\n    margin-bottom: 0.75rem;\n    color: #c62829;\n}\n\n.dashboard .card-columns .card .fa {\n    color: #e5e5e5;\n    padding: 5px;\n    border-radius: 3px;\n}\n\n.dashboard .card-columns .card .card-body {\n    padding: 20px;\n}\n\n.dashboard a:visited {\n    /* color: #383749; */\n    text-decoration: underline;\n}\n\n.text-orange {\n    color: #EF7F1A !important;\n}\n\n.text-black {\n    color: #383749 !important;\n}\n\n\n.url {\n    background: #EF7F1A;\n    padding: 0 8px;\n    color: #fff;\n    font-size: 13px;\n    justify-content: space-between;\n    margin: 0 4px;\n    line-height: 1.4;\n    margin-bottom: 25px !important;\n}\n\n.url a:visited {\n    color: #fff;\n}\n\n.text-sm {\n    font-size: 0.8rem;\n    color: #000000;\n}\n\n.select-box .form-select {\n    display: block;\n    /* padding: unset !important; */\n    font-weight: 400;\n    line-height: 1.5;\n    color: #212529;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 0.5px solid black !important;\n    /* appearance: auto; */\n    border-radius: unset !important;\n    transition: unset !important;\n    width: 156px;\n    height: 32px;\n    font-size: 13px;\n    text-align: left !important;\n}\n\n\n.form-control {\n    /* appearance: auto; */\n}\n\n.fa {\n    margin-right: 5px;\n}\n\n.modal-header .btn-close {\n    padding: calc(var(--bs-modal-header-padding-y)*0.5) calc(var(--bs-modal-header-padding-x)*0.5);\n    margin: calc(-0.5*var(--bs-modal-header-padding-y)) calc(-0.5*var(--bs-modal-header-padding-x)) calc(-0.5*var(--bs-modal-header-padding-y)) auto;\n}\n\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled),\nbutton:not(:disabled) {\n    cursor: pointer;\n}\n\n.btn-close {\n    box-sizing: content-box;\n    width: 1em;\n    height: 1em;\n    padding: 0.25em;\n    color: #000;\n    background: transparent url(data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3E%3Cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3E%3C/svg%3E) 50%/1em auto no-repeat;\n    border: 0;\n    border-radius: 0.375rem;\n    opacity: .5;\n}\n\n.cuisine .border-card {\n    border: 2px solid #c62829;\n}\n\n\n\n.react-select__control {\n    border-color: unset !important;\n    border-radius: unset !important;\n    border-style: unset !important;\n    border-width: unset !important;\n    box-sizing: border-box;\n    width: 110px !important;\n    float: right !important;\n}\n\n.react-select__indicator {\n    display: none !important;\n\n}\n\n.react-select__indicator span {\n    display: none !important;\n}\n\n\n.react-select__option .country-option {\n    margin-right: 5px !important;\n}\n\n.searchSet {\n    margin-top: -10px;\n    float: right;\n    display: flex;\n}\n\n#react-select-2-listbox {\n    width: 138px !important;\n    margin-left: 175px !important;\n}\n\n\n.clearButton {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    border-top-right-radius: 5px;\n    border-bottom-right-radius: 5px;\n    height: 34px;\n    width: 32px;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.react-select__menu-list {\n    overflow-y: hidden !important;\n    max-height: 389px !important;\n}\n\n.menu-card .card {\n    border: 0;\n    border-radius: 0;\n    box-shadow: unset;\n    padding: 0;\n    display: block;\n}\n\n.card-img-overlay .card {\n    border: 1px solid #eeeeee;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, .2), 0 6px 20px 0 rgba(0, 0, 0, .19);\n    margin-bottom: 0.5rem;\n    width: 90% !important;\n    padding: 11px;\n}\n\n/*.card-img-overlay .cardHeight {\n    height: 448px !important;\n}*/\n\n.card-img-overlay .temp-3 {\n    border: 0 !important;\n}\n\n.page-wrapper {\n    width: 595px;\n    height: 842px;\n}\n\n.card-img-overlay .card img {\n    width: -webkit-fill-available;\n    max-height: 295px;\n    min-height: auto;\n    height: 295px;\n    width: -moz-available;\n}\n\n.card-img-overlay .card .container {\n    border: 0 !important;\n    padding: 15px 10px !important;\n}\n\n.card-img-overlay .card .container h4 {\n    font-size: 1 rem !important;\n}\n\n.card-img-overlay p {\n    line-height: 1;\n}\n\n.menu-card .card .container {\n    border: 2px solid #889F2C;\n    padding: 25px;\n}\n\n.menu-card .card .container h6 {\n    text-transform: uppercase;\n    color: #545454;\n}\n\n.menu-card .desc {\n    line-height: 1;\n    font-size: 16px;\n    color: #878787;\n    display: flex !important;\n    justify-content: center !important;\n    margin-top: 10px;\n    margin-bottom: 5px;\n    margin-top: 5px;\n}\n\n\n.templete3 .desc {\n    justify-content: left !important;\n}\n\n\n\n\n.menu-card .price {\n    line-height: 1.4;\n    font-size: 18px;\n    color: #fff;\n    background: #c62829;\n    padding: 1px 5px;\n    font-weight: bold;\n}\n\n\n.menu-card .price1 {\n    line-height: 1.4;\n    font-size: 18px;\n    color: #fff;\n    background: #c62829;\n    padding: 1px 5px;\n    font-weight: bold;\n    float: left !important;\n}\n\n\n\n.menu-card .logo {\n    height: 60px;\n    margin-bottom: 10px;\n    width: auto;\n}\n\n.menu-card p {\n    line-height: 1.4;\n    font-size: 1rem;\n    color: #c62829;\n    border: 1px solid #c62829;\n    border-style: dashed;\n    padding: 0.2rem;\n    margin: 20px 0px 15px 0px;\n}\n\n@media only screen and (max-width: 767px) {\n    .menu-card .card {\n        width: auto;\n    }\n\n    .menu-card h2 {\n        font-size: 1rem;\n    }\n}\n\n.menu-card .img {\n    padding: 0 0 1rem 0;\n}\n\n.menu-card h2 {\n    color: #c62829;\n    font-size: 2.5rem;\n}\n\n.menu-card h3 {\n    margin: 1rem 0 0 0;\n}\n\n.card-img-overlay {\n    background-size: cover;\n    background-repeat: no-repeat;\n    display: block;\n    position: inherit;\n}\n\n/* .american_cuisine {\n  background-image: url(\"../images/American_cuisine.png\");\n  } */\n\n.address {\n    background: #ccc;\n    padding: 2px 8px;\n    font-size: 13px;\n    justify-content: space-between;\n    margin: 0 -15px;\n    line-height: 1.4;\n}\n\n.card-img-overlay {\n    padding-bottom: 0;\n}\n\n.text-orange {\n    color: #EF7F1A !important;\n}\n\n.text-black {\n    color: #383749 !important;\n}\n\n.url {\n    background: #EF7F1A;\n    padding: 0 8px;\n    color: #fff;\n    font-size: 1.5rem;\n    justify-content: space-between;\n    margin: 0;\n    line-height: 1.4;\n}\n\n.url a:visited {\n    color: #fff;\n}\n\n.modal-backdrop.show {\n    z-index: 999;\n}\n\n.modal-open .modal {\n    z-index: 999;\n}\n\n.accordion-button {\n    background-color: #c62829;\n    border-radius: 4px;\n    color: #fff;\n    margin-bottom: 40px;\n    padding: 6px 15px;\n    font-size: 16px;\n}\n\n.accordion-header h4 {\n    font-size: 16px;\n    margin-bottom: 0;\n}\n\n.accordion-button:not(.collapsed) {\n    background-color: #c62829;\n    border-radius: 4px;\n    color: #fff;\n    margin-bottom: 40px;\n    padding: 6px 15px;\n    font-size: 16px;\n}\n\n.accordion-button:focus {\n    border-color: #c62829;\n    box-shadow: unset;\n}\n\n.seemore {\n    position: absolute;\n    top: 24.7%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    color: white;\n    font-size: 16px;\n    border: none;\n    cursor: pointer;\n    text-align: center;\n}\n\n\n\n\n/* PDF Ganrate */\n.invoice-box {\n    max-width: 95%;\n    margin: auto;\n    padding: 0 10px 10px 10px;\n    font-size: 16px;\n    line-height: 24px;\n    font-family: Arial;\n    color: #555;\n    border: 1px solid #ccc;\n}\n\n\n.invoice-box .title img {\n    width: 300px;\n    border-top: 15px solid #EF7F1A;\n}\n\n\n.logoPreview {\n    height: 50px;\n    width: 62px;\n}\n\n.item-image {\n    width: 150px;\n    height: 150px;\n}\n\n\n.invoice-box table {\n    width: 100%;\n    line-height: inherit;\n    text-align: left;\n}\n\n.invoice-box table td {\n    padding: 5px;\n    vertical-align: top;\n}\n\n.invoice-box table tr td:nth-child(7) {\n    text-align: center;\n}\n\n.invoice-box table tr td:nth-child(5) {\n    text-align: center;\n}\n\n.invoice-box table tr td:nth-child(6) {\n    text-align: center;\n}\n\n.invoice-box table tr.top table td {\n    padding-bottom: 20px;\n}\n\n.invoice-box table tr.top table td.title {\n    text-align: center;\n}\n\n.inv {\n    font-size: 55px;\n    line-height: 45px;\n    color: #60CAFF;\n    text-align: center;\n}\n\n.invoice-box table tr.information table td {\n    padding-bottom: 10px;\n    width: 300px;\n}\n\n.invoice-box table tr.information table td.sub-title {\n    font-size: 24px;\n    color: #030303;\n    font-family: roboto;\n}\n\n.invoice-box table tr.information table td.billto {\n    color: #fff;\n    background: #6ACEFF;\n    width: 300px;\n    padding-bottom: 10px !important;\n}\n\n.invoice-box table tr.heading td {\n    border-bottom: 1px solid #ccc;\n    font-weight: bold;\n    text-align: center;\n}\n\n.invoice-box table tr.heading-blue td {\n    background: #fff;\n    border-bottom: 1px solid #ccc;\n    font-weight: bold;\n    color: #000;\n    border-top: 1px solid #ccc;\n}\n\n.invoice-box table tr.details td {\n    padding-bottom: 20px;\n    border-bottom: 1px solid #ccc;\n}\n\n.invoice-box table tr.item td {\n    border-bottom: 1px solid #eee;\n}\n\n.invoice-box table tr.item.last td {\n    border-bottom: none;\n}\n\n.invoice-box table tr.total td:nth-child(2) {\n    border-top: 2px solid #eee;\n    font-weight: bold;\n}\n\n.td-border {\n    border: 1px solid #6ACEFF;\n}\n\n@media only screen and (max-width: 600px) {\n    .invoice-box table tr.top table td {\n        width: 100%;\n        display: block;\n        text-align: center;\n    }\n\n    .invoice-box table tr.information table td {\n        width: 100%;\n        display: block;\n        text-align: center;\n    }\n}\n\n.invoice-box table .information td strong {\n    font-size: 18px;\n}\n\n.invoice-box .inv-des {\n    font-size: 13px;\n    font-style: italic;\n    font-weight: bold;\n    margin-top: -8px;\n}\n\n.invoice-box table div span {\n    padding-left: 16%;\n}\n\n\n.invoice-box .td-border {\n    border: 1px solid #6ACEFF;\n}\n\n.invoice-box .sm-text {\n    line-height: 1.5;\n    font-size: 13px;\n    font-style: italic;\n    font-weight: bold;\n    margin-top: -8px;\n}\n\n.invoice-box .footer-sm-text {\n    line-height: 1.5;\n    font-size: 12px;\n    font-weight: bold;\n    margin-top: 15px;\n    text-align: center;\n}\n\n.invoice-box .redline {\n    border: 2px solid #c62829;\n    width: 31%;\n    margin-top: 80px;\n    opacity: 9;\n}\n\n.redlinethick {\n    border: 8px solid #c62829;\n    width: 60%;\n    margin-top: 40px;\n    margin-bottom: 0;\n    opacity: 9;\n}\n\n\n/** RTL **/\n.invoice-box .rtl {\n    direction: rtl;\n    font-family: Tahoma, 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;\n}\n\n.invoice-box .rtl table {\n    text-align: right;\n}\n\n.invoice-box .rtl table tr td:nth-child(2) {\n    text-align: left;\n}\n\n/* end */\n.menu-flags-button {\n    font-size: 15px !important;\n    width: 192px !important;\n    float: right;\n    height: 34px;\n    margin-bottom: 5px;\n}\n\n@media screen and (min-width: 992px) {\n    .site-navigation ul {\n        position: absolute;\n        top: 37px;\n        left: auto;\n        width: 100%;\n        height: auto;\n        padding: 0;\n        background: #fff;\n        z-index: 1000;\n        overflow: auto;\n    }\n}\n\n.loading-overlay {\n    display: none;\n    background: rgba(255, 255, 255, 0.7);\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    top: 0;\n    z-index: 9998;\n    align-items: center;\n    justify-content: center;\n}\n\n.loading-overlay.is-active {\n    display: flex;\n}\n\n.page-wrapper .address {\n    width: 98vw !important;\n    position: absolute;\n    bottom: 0;\n}\n\n.preview_main .image_height {\n    /*height: 320px;*/\n    height: 26vw;\n}\n\n.preview_main .card-img-overlay .card img {\n    max-height: -webkit-fill-available;\n    height: -webkit-fill-available;\n}\n\n.preview_main .menu-card .desc {\n    margin-bottom: 0px;\n}\n\n\n\n\n@-webkit-keyframes spinner-border {\n    to {\n        -webkit-transform: rotate(360deg)\n            /* rtl:ignore */\n        ;\n        transform: rotate(360deg)\n            /* rtl:ignore */\n        ;\n    }\n}\n\n@keyframes spinner-border {\n    to {\n        -webkit-transform: rotate(360deg)\n            /* rtl:ignore */\n        ;\n        transform: rotate(360deg)\n            /* rtl:ignore */\n        ;\n    }\n}\n\n.spinner-border {\n    display: inline-block;\n    width: 2rem;\n    height: 2rem;\n    vertical-align: -0.125em;\n    border: 0.25em solid currentColor;\n    border-right-color: transparent;\n    border-radius: 50%;\n    -webkit-animation: 0.75s linear infinite spinner-border;\n    animation: 0.75s linear infinite spinner-border;\n}\n\n.spinner-border-sm {\n    width: 1rem;\n    height: 1rem;\n    border-width: 0.2em;\n}\n\n.spinner-position {\n    margin-top: -27px;\n    float: right;\n    margin-right: 10px;\n}\n\n\n.register-page .page-product {\n    background: url(\"../images/supply_baner.png\") no-repeat center !important;\n    height: 260px;\n}\n\n.register-page .inner-header {\n    background: url(\"../images/BANER_Dashboard.jpg\") no-repeat center;\n    height: 260px;\n}\n\n\n/* .register-page .dashboard_img {\n    background: url(\"../images/BANER_Dashboard.jpg\") no-repeat center;\n    height: 260px;\n} */\n\n.register-page .inner-header-payment {\n    background: url(\"../images/header-payment.png\") no-repeat center;\n    height: 260px;\n}\n\n.pdf_button {\n    text-align: initial;\n    margin-bottom: 8px;\n    justify-content: space-between;\n}\n\n.downloadPdf {\n    border-radius: 6px;\n}\n\n\n.templete3 {\n    width: 100% !important;\n    border: 0;\n    height: auto;\n    padding: 20px;\n}\n\n.templete3 .container {\n    text-align: left;\n    border-bottom: 1px solid #ccc !important;\n    padding: 20px !important;\n    /* border-style: dotted !important; */\n    margin-top: 0;\n}\n\n.templete3 .price {\n    float: right;\n    bottom: auto;\n    position: inherit;\n    margin-top: -20px;\n}\n\n.set_select {\n    padding-top: 1rem;\n}\n\n\n.image_height {\n    height: 300px;\n}\n\n.text-sm-10 {\n    font-size: 10px;\n}\n\n.item-h4 {\n    font-size: 1rem !important;\n}\n\n.text-sm-12 {\n    font-size: 12px;\n}\n\n\n.menu-card .quantity {\n    line-height: 1.4;\n    font-size: 18px;\n    color: #fff;\n    background: #383749;\n    padding: 1px 5px;\n    font-weight: 500;\n    bottom: 10px;\n    float: left;\n    margin-left: 16px;\n\n}\n\n.justify-content {\n    justify-content: space-between;\n}\n\n.fix_height {\n    font-size: 20px;\n    margin-bottom: 25px;\n}\n\nbutton.emenubtm {\n    margin-top: -40px;\n}\n\n.cont-bg.shopping-cart-page {\n    height: 100vh;\n}\n\n.pdf_button2 {\n    text-align: initial;\n    padding: 14px 71px 8px 72px;\n    justify-content: space-between;\n}\n\n.price_unit {\n    float: right;\n    display: grid;\n    margin-top: -90px;\n}\n\n\n.price_unit .price1 {\n    line-height: 1.4;\n    font-size: 13px;\n    color: #fff;\n    background: #c62829;\n    padding: 4px;\n    text-align: center;\n    /* margin-top: -46px; */\n}\n\n\n.price_unit .quantity1 {\n    line-height: 1.4;\n    font-size: 13px;\n    color: #fff;\n    background: #383749;\n    ;\n    margin-top: 18px;\n    padding: 8px;\n    text-align: center;\n}\n\n.shadow {\n    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%);\n}\n\n.selct-temp {\n    justify-content: end;\n}\n\n@media screen and (max-width: 767px) {\n    .selct-temp {\n        justify-content: center;\n    }\n}\n\n.selct-back {\n    justify-content: start;\n}\n\n@media screen and (max-width: 767px) {\n    .selct-back {\n        justify-content: center;\n    }\n}\n\nimg.restaurantLogo {\n    width: 60px;\n    height: auto;\n}\n\nimg.cuisineImg {\n    width: 30px;\n    height: auto;\n}\n\nhr.linewithspace {\n    margin-top: 20px;\n}\n\ntd.address {\n    background: white;\n    font-weight: 100;\n}\n\ntd.addressIcon {\n    vertical-align: top;\n}\n\na.WhiteTxt {\n    color: white;\n    text-decoration: none;\n}\n\nh4.card-text {\n    color: #c62829;\n    font-size: 20px;\n}\n\np.emenulink {\n    color: #c62829;\n    font-size: 12px;\n    line-height: 1.2;\n}\n\n.flags-dropdown #rfs-btn {\n    margin: 0px;\n    padding: 0px 10px;\n    border: none;\n    font-size: 16px;\n}\n\n.flags-dropdown ul {\n    margin-top: 21px !important;\n    padding: 0px 0px;\n    max-height: 360px;\n}\n\n.ReactFlagsSelect-module_selectOptionWithlabel__2GpmM {\n    padding: 2px 10px;\n}\n\n.flex-column {\n    flex-direction: row !important;\n}\n\n.nav-pills {\n    --bs-nav-pills-link-active-bg: #198754 !important;\n}\n\n.heder_dropdown {\n    border: 1px solid #c62829;\n    ;\n    border-radius: unset;\n    height: 32px;\n    /* width: 150px; */\n}\n\n\n.drp_button {\n    margin-top: -2px;\n    border: unset;\n    border-radius: unset !important;\n    height: 32px;\n}\n\n.drp_button .btn:hover {\n    color: unset !important;\n    background-color: unset !important;\n    border-color: unset !important;\n}\n\n.drp_button .btn.show {\n    color: unset !important;\n    background-color: unset !important;\n    border-color: unset !important;\n}\n\n.item_border {\n    border: 1px solid #c62829;\n    ;\n}\n\n.show_drop {\n    padding: 0px 0px 0px 0px;\n}\n\nh4.card-text.EProductCard {\n    padding: 15px 12px;\n}\n\nselect.goog-te-combo {\n    padding: 12px;\n    border: none;\n}\n\n.login_link {\n    display: flex;\n    justify-content: space-between;\n}\n\n@media screen and (max-width: 767px) {\n    .login_link {\n        display: block\n    }\n}\n\np.card-text.cuisinesName {\n    font-size: 13px;\n}\n\n.service-ht {\n    height: 60px;\n}\n\n.address-ht {\n    min-height: 160px;\n}\n\n.fa-map-marker {\n    font-size: 1.3rem;\n}\n\n.fa-phone {\n    font-size: 1.2rem;\n}\n\n.fa-globe {\n    font-size: 1.2rem;\n}\n\n.emenubtm {\n    text-align: center;\n    text-decoration: none;\n    color: #fff !important;\n}\n\n.tickimg {\n    height: 38px;\n    width: 50px;\n    position: block;\n    /* margin-top: 54px; */\n    z-index: 2;\n    margin-left: -7px;\n}\n\n.cuisine {\n    overflow-y: auto;\n    height: 800px;\n}\n\n@media screen and (max-width: 767px) {\n    .cuisine {\n        height: 500px;\n    }\n}\n\n.showbackPreview {\n    height: 800px;\n\n}\n\n.bgImage {\n    height: 100%;\n    width: auto;\n}\n\n.navbar-dark .navbar-nav .nav-link {\n    color: white;\n    font-size: 1rem;\n    text-align: left;\n}\n\ndiv#basic-navbar-nav {\n    text-align: right;\n    margin-right: 20px;\n}\n\n.navbar-toggler:focus {\n    box-shadow: none;\n}\n\n.ancertags a {\n    color: unset !important;\n}\n\n.setAncer {\n    color: unset !important;\n}\n\n.visit_link:visited {\n    color: #fff;\n}\n\n.pullRight {\n    float: right;\n}\n\n#previewPdf .container {\n    width: 100% !important;\n    max-width: 100% !important;\n}\n\n.menu-card .container {\n    width: 100% !important;\n    max-width: 100% !important;\n}\n\n#previewPdf .address {\n    background-color: #abaab;\n    color: #000;\n    font-size: 1.5rem;\n    padding: 1rem;\n}\n\n.sec_code {\n    justify-content: space-between !important;\n    display: flex;\n}\n\n.select_cuisine1 {\n    padding: 80px;\n    text-align: center;\n}\n\n\n\n/* \ninput[type=\"checkbox\"] {\n    -webkit-appearance: none;\n    position: relative;\n    width: 100%;\n    cursor: pointer;\n    z-index: 1;\n  }\n\n  input[type=\"checkbox\"]:after {\n    position: absolute;\n    font-family: \"Font Awesome 5 Free\";\n    font-weight: 400;\n    content: \"\\f111\";\n    font-size: 18px;\n    color: #478bfb;\n    right: 10px;\n    top: -5px;\n    z-index: 1;\n  }\n  \n  input[type=\"checkbox\"]:checked:after {\n    font-weight: 900;\n    content: \"\\f058\";\n    color: #478bfb;\n    z-index: 1;\n  } */\n\n\n\ninput[type=\"checkbox\"][id^=\"myCheckbox\"] {\n    display: none;\n}\n\n\n.mylabel {\n    /* border: 1px solid #fff; */\n    /* padding: 10px; */\n    display: block;\n    position: relative;\n    /* margin: 10px; */\n    cursor: pointer;\n}\n\n.mylabel:before {\n    background-color: white;\n    color: white;\n    content: \" \";\n    display: block;\n    border-radius: 50%;\n    /* border: 1px solid grey; */\n    position: absolute;\n    top: -13px;\n    left: 13px;\n    width: 30px;\n    height: 30px;\n    text-align: center;\n    line-height: 28px;\n    transition-duration: 0.4s;\n    transform: scale(0);\n    z-index: 1;\n}\n\n.mylabel {\n    border-color: #ddd;\n}\n\n.mylabel:before {\n    content: \"✓\";\n    font-size: 35px;\n    background-color: #c62829;\n    transform: scale(1);\n    z-index: 1;\n}\n\n.checklabel:before {\n    background-color: white;\n    color: white;\n    content: \" \";\n    display: block;\n    border-radius: 50%;\n    /* border: 1px solid grey; */\n    position: absolute;\n    top: -13px;\n    left: 20px;\n    width: 30px;\n    height: 30px;\n    text-align: center;\n    line-height: 28px;\n    transition-duration: 0.4s;\n    transform: scale(0);\n    z-index: 1;\n}\n\n\n.checklabel:before {\n    border: 2px solid #ccc;\n    transform: scale(1);\n}\n\n\n@media screen and (max-width: 767px) {\n    .mobile_set {\n        display: flex !important;\n    }\n\n}\n\n@media screen and (min-width: 992px) {\n    .navbar-expand-lg .navbar-nav .nav-link {\n        padding-right: 0.5rem;\n        padding-left: 0;\n    }\n}\n\n@media screen and (min-width: 991px) and (max-width: 1198px) {\n    .navbar-expand-lg .navbar-nav .nav-link {\n        padding-right: 0.5rem;\n        font-size: 0.8rem;\n    }\n}\n\n.showTranslate {\n    display: none !important;\n}\n\n.switchSize {\n    font-size: medium;\n}\n\n\n\n/* CSS */\n.button-1 {\n    background-color: #c62829;\n    border-radius: 8px;\n    border-style: none;\n    box-sizing: border-box;\n    color: #FFFFFF;\n    cursor: pointer;\n    display: inline-block;\n    font-family: \"Haas Grot Text R Web\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    font-size: 14px;\n    font-weight: 500;\n    height: 40px;\n    line-height: 20px;\n    list-style: none;\n    margin: 0;\n    outline: none;\n    padding: 10px 16px;\n    position: relative;\n    text-align: center;\n    text-decoration: none;\n    transition: color 100ms;\n    vertical-align: baseline;\n    user-select: none;\n    -webkit-user-select: none;\n    touch-action: manipulation;\n}\n\n.button-1:hover,\n.button-1:focus {\n    background-color: #c62829;\n}\n\nhtml {\n    user-select: none !important;\n}\n\n\n.btn-menu-not {\n    background-color: #EF7F1A;\n    color: white;\n    font-size: 18px;\n    border: none;\n    cursor: pointer;\n    border-radius: 0px;\n    text-align: center;\n    width: 198px;\n    height: 40px;\n}\n\n.btn-products-not {\n    background-color: #c62829;\n    color: white;\n    font-size: 18px;\n    border: none;\n    cursor: pointer;\n    border-radius: 0px;\n    text-align: center;\n    width: 198px;\n    height: 40px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
